import store from 'store'
import * as API from '../api'
import MobileDetect from 'mobile-detect'
import qs from 'qs'
import {
  extendModel,
  /*cfBelongsToAdult,*/
  padNum,
  isValidStep,
  getStepSlug,
  getUnderageQueryString,
  pushRoute,
  isEntityInvalid,
  scrollToFirstInvalidComponent,
  getEnv,
  posProducts
} from '../../utils'
import { request } from '../api'
import { normalize } from 'normalizr'
import { union /*, uniqBy*/ } from 'lodash'
import uuid from 'uuid'
import { widgetListSchema } from '../schema'
import { updateProduct } from './productActions'
import { updateAllWidgets, updateWidget } from './widgetsActions'
import { getPECAddressComponent,getDocumentoRulesComponent } from './../static/addressStatic'
import { getPromoCodeComponent } from './../static/promoCodeStatic'
import { getPosPlanComponent } from './../static/posPlanStatic'
import {
  updateAllComponents,
  updateComponent,
  validateComponent,
  autoFillDependantComponents,
  tweakAgreement,
  invokeMethod,
  activateSign,
  parseQuestionarioWidgets
} from './componentsActions'
import * as Model from './../stateExtension'
import * as TitolareStatic from './../static/titolareStatic'
import * as FirmeStatic from './../static/firmeStatic'
import {FetchPOSPlan} from '../../state/api'
const md = new MobileDetect(window.navigator.userAgent)

/**
 * Actions you can make on steps
 * @module  {Actions} stepActions
 */
export const DEAL_ACTION_TOKEN = '@@step/DEAL_ACTION_TOKEN'
export const HANDLE_SERVER_ERRORS = '@@step/HANDLE_SERVER_ERRORS'
export const TOGGLE_LOGIN_FORM = '@@step/TOGGLE_LOGIN_FORM'
export const UPDATE_AUTH_STEP = '@@step/UPDATE_AUTH_STEP'
export const UPDATE_STEP = '@@step/UPDATE'
export const SHOW_ADDRESS_MODAL = '@@step/SHOW_ADDRESS_MODAL'
export const HIDE_ADDRESS_MODAL = '@@step/HIDE_ADDRESS_MODAL'
export const SHOW_WEBCAM_MODAL = '@@step/SHOW_WEBCAM_MODAL'
export const HIDE_WEBCAM_MODAL = '@@step/HIDE_WEBCAM_MODAL'
export const ACCEPTED_INVITATION = '@@step/ACCEPTED_INVITATION'
export const SET_IS_UNDERAGE = '@@step/SET_IS_UNDERAGE'
export const SET_IS_PARENT = '@@step/SET_IS_PARENT'
export const SET_CONTACT_INFO = '@@step/SET_CONTACT_INFO'
export const SET_REQUEST_LIST = '@@step/SET_REQUEST_LIST'
export const SET_CONTRACT_LIST = '@@step/SET_CONTRACT_LIST'
export const PUSH_ANALYTICS = '@@step/PUSH_ANALYTICS'
export const SHOW_LOADING = '@@components/SHOW_LOADING'
export const HIDE_LOADING = '@@components/HIDE_LOADING'
export const USER_COUNTER = '@@components/USER_COUNTER'
export const ENABLE_BUTTON = '@@step/ENABLE_BUTTON'
export const DISABLE_BUTTON = '@@step/DISABLE_BUTTON'
export const SET_TITOLARE_LIST = '@@step/SET_TITOLARE_LIST'
export const UPDATE_COMPONENT = '@@components/UPDATE'
export const SHOW_API_ALERT_MODAL = '@@step/SHOW_API_ALERT_MODAL'

/**
 * The API root
 * @private
 */
const API_ROOT = process.env.API_ROOT

const getStoredState = () => {
  const proto = {
    setAuth(authenticated) {
      if (authenticated === undefined)
        throw new Error('missing required argument: authenticated')

      store.set('hype-signup', { ...this, authenticated })
    },
    updateSession(contactId, stepNumber, isParent) {
      const reachedStepKey = !!isParent ? 'parentReachedStep' : 'reachedStep'

      if (
        !!contactId &&
        (!this.sessions[contactId] ||
          (this.sessions[contactId][reachedStepKey] || 0) < stepNumber)
      ) {
        store.set('hype-signup', {
          ...this,
          sessions: {
            ...this.sessions,
            [contactId]: {
              ...(this.sessions[contactId] || {}),
              [reachedStepKey]: stepNumber
            }
          }
        })
      }
    },
    getSessionStep(contactId, isParent) {
      const reachedStepKey = !!isParent ? 'parentReachedStep' : 'reachedStep'
      return (
        (this.sessions[contactId] &&
          this.sessions[contactId][reachedStepKey]) ||
        0
      )
    }
  }

  const storedState = store.get('hype-signup') || {
    authenticated: false,
    sessions: {}
  }

  return Object.assign(Object.create(proto), storedState)
}

const rewriteRoute = baseQs => (dispatch, getState) => {
  const { step, routing, product, components } = getState()

  if (!!product && !!product.partnership) {
    //@remarks necessary while changing flow in-step (eg: ADECCO promo code)
    routing.flow = product.flow
    routing.partnership = product.partnership
    routing.convention = product.convention
  }

  if (!routing.partnership) return

  let routePath = `/${routing.container}/${routing.flow}${
    routing.argument ? '/' + routing.argument : ''
  }`

  let underageQs = '?'

  if (!!step.number) {
    if (isValidStep(step.number, product)) {
      routePath = `/request/${routing.flow}/${getStepSlug(step, product)}`
      underageQs = getUnderageQueryString(step)
    } else {
      if (
        !!components['THANKS-RESUME_INTEST_2'] &&
        !!components['THANKS-RESUME_INTEST_2'].value
      ) {
        routePath = `/thanks/${routing.flow}/${
          components['THANKS-RESUME_INTEST_2'].value
        }`
      } else {
        routePath = `/thanks/${routing.flow}`
      }
    }
  } else {
    return
  }

  const newQs = qs.stringify(
    {
      ...qs.parse(baseQs || '', { ignoreQueryPrefix: true }),
      ...qs.parse(underageQs, { ignoreQueryPrefix: true })
    },
    { addQueryPrefix: true }
  )

  if (
    routing.locationBeforeTransitions.pathname !== routePath ||
    routing.locationBeforeTransitions.search.indexOf(newQs.replace('?', '')) < 0
  ) {
    pushRoute(
      routePath + newQs,
      true,
      routing.partnership === 'HYPE4TIM' ? ['code', 'state'] : []
    )
  }
}

const pushAnalytics = () => dispatch => {
  dispatch({ type: PUSH_ANALYTICS })
}

const updateStep = step => (dispatch /*, getState*/) => {
  dispatch({
    type: UPDATE_STEP,
    step
  })
}

/*#Removed4POS*/
/*const setContactInfo = contact => (dispatch) => {
  dispatch({
    type: SET_CONTACT_INFO,
    contact
  })
}
*/
export const ActionToken = (actionName, notBlocking) => {
  return { id: uuid(), actionName, blocking: !notBlocking }
}

/**
 * Toggles a step loader tracing the caller
 * @param  {Object}     token            The token containing the action initiator and the disposable flag
 * @return {Function}                    unknown
 */
export const dealActionToken = token => (dispatch /*, getState*/) => {
  dispatch({ type: DEAL_ACTION_TOKEN, token })
}

/**
 * Handle errors generated by API calls
 *
 * @param  {Object} json      The response json
 * @return {Function}         Dispatches an HANDLE_SERVER_ERRORS action
 */
const handleServerErrors = json => dispatch => {
  if (json && json.status !== 'success') {
    const errorsMap = {
      'Unable to find required metadata: abi, template, code':
        'Per proseguire è necessario inserire il codice OTP',
      'Item not found!': 'La pratica richiesta non è stata trovata.',
      'Invalid OTP': 'Il codice OTP inserito non è valido.',
      'Non sono state trovate pratiche associate ai dati inseriti.':
        'Non sono state trovate pratiche associate ai dati inseriti.',
      "Attenzione, le credenziali inserite non si riferiscono all'intestatario della richiesta. Non e' possibile proseguire.":
        "Le credenziali inserite non si riferiscono all'intestatario della richiesta.<br>Non è possibile proseguire.",
      "The parameters 'cf', 'mail', 'prefCell' and 'numCell' are mandatory.":
        'I campi "Codice Fiscale", "Email" e "Numero Cellulare" sono obbligatori',
      'tim-unauthorized': `
        <div>
          Autenticazione scaduta o non valida.<br/>
          <a href="${
            json.redirectUri
          }" >Torna a TIM MobileConnect</a> per riprovare.
        </div>
        `,
      'OTP exhausted': `<div>
          Numero consentito di OTP erogabili per la pratica superato.<br/>
          Creare una nuova pratica.
        </div>`,
      'OTP expired': `<div>
            Codice OTP scaduto.<br/>
            Richiedi un nuovo codice cliccando sul pulsante Reinvia OTP o ricaricando la pagina.
          </div>`
    }

    let message = errorsMap[json.message]

    if (json.status === 'error' || json.status === 'bad_request') {
      message =
        message || 'Si è verificato un errore imprevisto. Riprova più tardi.'
    } else if (
      json.status === 'unauthorized' ||
      json.status === 'invalid_login'
    ) {
      message = message || 'Operazione non permessa.'
    } else if (json.status === 'not_found') {
      message = message || 'La risorsa richiesta non esiste.'
    } else {
      message =
        message || 'Si è verificato un errore imprevisto. Riprova più tardi.'
    }

    dispatch({
      type: HANDLE_SERVER_ERRORS,
      hasServerErrors: true,
      serverErrorStatus: json.status,
      serverErrorMessage: message
    })
  }
}

/**
 * Shows the login form
 * @public
 *
 * @param {Boolean} visibility  The visibility flag
 * @return {Function}           Dispatches an HANDLE_SERVER_ERRORS action
 */
export const toggleLoginForm = visibility => (dispatch, getState) => {
  const { widgets, step, product } = getState()

  if (!!widgets.LOGIN_SE_CLIENTE && !visibility) {
    dispatch(updateWidget('LOGIN_SE_CLIENTE', { status: ['hidden'] }))
  }

  dispatch({ type: TOGGLE_LOGIN_FORM, loginFormVisible: !!visibility })
  pushRoute(
    `/request/${product.flow}/${
      !!visibility ? 'auth' : getStepSlug(step, product)
    }`,
    true
  )
}

/**
 * Hides the login form and
 * @public
 *
 * @return {Function}           Dispatches an HANDLE_SERVER_ERRORS action
 */
export const authenticated = () => dispatch => {
  getStoredState().setAuth(true)
  dispatch(toggleLoginForm(false))
}

export const unauthenticated = token => dispatch => {
  getStoredState().setAuth(false)
  dispatch(updateAuthStep())
  if (!!token) {
    dispatch(dealActionToken({ ...token, dispose: true }))
  }
}

export const updateAuthStep = auth => dispatch => {
  dispatch({ type: UPDATE_AUTH_STEP, auth })
}

export const authStep = body => dispatch => {
  const token = new ActionToken('step.authStep')

  dispatch(dealActionToken(token))

  if (!!body.callbacks) {
    const userNameCallback = body.callbacks.find(
      c => c.type === 'NameCallback' && c.output[0].value === 'USER_CODE'
    )
    if (!!userNameCallback) {
      userNameCallback.input[0].value = padNum(
        userNameCallback.input[0].value,
        8
      )
    }
  }

  API.auth(body)
    .then(json => {
      dispatch(updateAuthStep(json))
      dispatch(dealActionToken({ ...token, dispose: true }))
    })
    .catch(json => {
      dispatch(updateAuthStep(json))
      dispatch(dealActionToken({ ...token, dispose: true }))
    })
}

export const logout = () => dispatch => {
  const token = new ActionToken('step.logout')

  dispatch(dealActionToken(token))

  API.unauth()
    .then((/*json*/) => {
      dispatch(unauthenticated(token))
    })
    .catch((/*json*/) => {
      //@remarks this will always fail even if the response is 200
      //because it won't return any json
      dispatch(unauthenticated(token))
    })
}

/**
 * Updates the state specifying if the contractor is underage
 *
 * @param  {string} codiceFiscale    The Codice Fiscale
 * @return {Function}                Dispatches a SET_IS_UNDERAGE action
 */
/*#Removed4POS*/
/*const setIsUnderage = codiceFiscale => (dispatch) => {
  dispatch({
    type: SET_IS_UNDERAGE,
    isUnderage: !cfBelongsToAdult(codiceFiscale)
  })
}
*/
const setIsParent = () => (dispatch, getState) => {
  if (!!getState().step.isUnderage) {
    dispatch({ type: SET_IS_UNDERAGE, isUnderage: false })
  }

  dispatch({ type: SET_IS_PARENT, isParent: true })

  getStoredState().updateSession(
    getState().step.contactId,
    getState().step.number,
    true
  )
}

/**
 * Invitation Callback
 * @param  {Object} token The ActionToken
 * @param  {Object} json  The invitation object
 * @return {null}         nothing
 */
/*#Removed4POS*/
/*const invitationCallback = (token, json) => (dispatch, getState) => {
  if (json.status === 'success') {
    const { step } = getState()

    dispatch(
      setContactInfo({
        codiceFiscale: json.data.codiceFiscale,
        email: json.data.email,
        phoneNumber: json.data.phoneNumber
      })
    )

    if (step.isUnderage === null && !!json.data.codiceFiscale) {
      dispatch(setIsUnderage(json.data.codiceFiscale))
    }

    return API.getInvitations(step.contactId).then(jsonArrWrapper => {
      if (
        uniqBy(jsonArrWrapper.data, 'codiceFiscale').length >= 2 &&
        !step.isParent
      ) {
        dispatch(setIsParent())
      }
      dispatch(dealActionToken({ ...token, dispose: true }))
      return { ...jsonArrWrapper, lastData: json.data }
    })
  }
}*/

/**
 * Decrypts third party data using the hype key
 * @param {Object} proof           The encrypted third party data container
 * @return {Promise}               Promise
 */
/*#Removed4POS*/
/*const decryptHypeProof = proof => (dispatch, getState) => {
  const { components } = getState()

  if (
    !!components['SIGNALER-REFERRER'] &&
    !components['SIGNALER-REFERRER'].value
  ) {
    dispatch(updateComponent('SIGNALER-REFERRER', { value: proof.value }))
  }
}*/

/**
 * Populates the SIGNALER-CAMPAIGN_URL component with the campaign querystring
 *
 * @param {string} campaignQs           The campaign querystring
 * @return {undefined}                    undefined
 */
/*#Removed4POS*/
/*const updateCampaignUrl = campaignQs => (dispatch, getState) => {
  const { components } = getState()

  if (
    !!components['SIGNALER-CAMPAIGN_URL'] &&
    !components['SIGNALER-CAMPAIGN_URL'].value
  ) {
    dispatch(updateComponent('SIGNALER-CAMPAIGN_URL', { value: campaignQs }))
  }
}*/

/**
 * Populates the SIGNALER-PROMO_CODE component with the promoCode querystring value
 *
 * @param {string} promoCode              The promo code
 * @param {boolean} locked                 The readonly flag
 * @return {undefined}                    undefined
 */
/*#Removed4POS*/
/*const updatePromoCode = (promoCode, locked) => (dispatch, getState) => {
  const { components } = getState()

  if (
    !!components['SIGNALER-PROMO_CODE'] &&
    !components['SIGNALER-PROMO_CODE'].value
  ) {
    dispatch(updateComponent('SIGNALER-HAS_PROMO_CODE_NO', { value: '' }))
    dispatch(
      updateComponent('SIGNALER-HAS_PROMO_CODE_YES', { value: 'selected' })
    )
    dispatch(
      updateComponent('SIGNALER-PROMO_CODE', {
        value: promoCode,
        status: !!locked
          ? [
              ...new Set([
                ...components['SIGNALER-PROMO_CODE'].status,
                'readonly'
              ])
            ]
          : components['SIGNALER-PROMO_CODE'].status.filter(
              s => s !== 'readonly'
            )
      })
    )
  }
}*/

/**
 * Decrypts third party data using the yoox key
 * @param {Object} proof           The encrypted third party data container
 * @return {Promise}               Promise
 */
/*#Removed4POS*/
/*const decryptYooxProof = proof => (dispatch, getState) => {
  const token = new ActionToken('step.decryptYooxProof')

  const { step, components } = getState()

  dispatch(dealActionToken(token))

  return API.decryptYooxProof(proof).then(json => {
    switch (step.number) {
      case 1:
        if (
          !!components['JOLLY-JOLLY_INPUT'] &&
          !components['JOLLY-JOLLY_INPUT'].value
        ) {
          dispatch(
            updateComponent('JOLLY-JOLLY_INPUT', { value: json.data.idyoox })
          )
        }

        if (
          !!components['NOME_COGNOME-NOME'] &&
          !components['NOME_COGNOME-NOME'].value
        ) {
          dispatch(
            updateComponent('NOME_COGNOME-NOME', { value: json.data.name })
          )
        }

        if (
          !!components['NOME_COGNOME-COGNOME'] &&
          !components['NOME_COGNOME-COGNOME'].value
        ) {
          dispatch(
            updateComponent('NOME_COGNOME-COGNOME', {
              value: json.data.surname
            })
          )
        }

        if (
          !!components['CODICE_FISCALE-CF'] &&
          !components['CODICE_FISCALE-CF'].value
        ) {
          dispatch(
            updateComponent('CODICE_FISCALE-CF', { value: json.data.cf })
          )
        }

        if (
          !!components['CELLULARE-NUM_CELLULARE'] &&
          !components['CELLULARE-NUM_CELLULARE'].value
        ) {
          dispatch(
            updateComponent('CELLULARE-NUM_CELLULARE', {
              value: json.data.mobile
            })
          )
        }

        if (
          !!components['CELLULARE-CONFERMA_NUM_CELLULARE'] &&
          !components['CELLULARE-CONFERMA_NUM_CELLULARE'].value
        ) {
          dispatch(
            updateComponent('CELLULARE-CONFERMA_NUM_CELLULARE', {
              value: json.data.mobile
            })
          )
        }

        if (!!components['EMAIL-EMAIL'] && !components['EMAIL-EMAIL'].value) {
          dispatch(updateComponent('EMAIL-EMAIL', { value: json.data.mail }))
        }

        if (
          !!components['EMAIL-CONFERMA_EMAIL'] &&
          !components['EMAIL-CONFERMA_EMAIL'].value
        ) {
          dispatch(
            updateComponent('EMAIL-CONFERMA_EMAIL', { value: json.data.mail })
          )
        }

        break
      case 2:
        if (
          !!components['RESIDENZA-PROVINCIA'] &&
          !components['RESIDENZA-PROVINCIA'].value
        ) {
          dispatch(
            updateComponent('RESIDENZA-PROVINCIA', {
              value: json.data.address.provice.toUpperCase()
            })
          )
        }

        if (
          !!components['RESIDENZA-CITTA'] &&
          !components['RESIDENZA-CITTA'].value
        ) {
          dispatch(
            updateComponent('RESIDENZA-CITTA', {
              value: json.data.address.city
            })
          )
        }

        if (
          !!components['RESIDENZA-INDIRIZZO'] &&
          !components['RESIDENZA-INDIRIZZO'].value
        ) {
          dispatch(
            updateComponent('RESIDENZA-INDIRIZZO', {
              value: json.data.address.address
            })
          )
        }

        if (
          !!components['RESIDENZA-CAP'] &&
          !components['RESIDENZA-CAP'].value
        ) {
          dispatch(
            updateComponent('RESIDENZA-CAP', { value: json.data.address.cap })
          )
        }

        break
    }

    dispatch(dealActionToken({ ...token, dispose: true }))
  })
}*/

/**
 * Gets invitation data for the actual contactId
 *
 * @return {Function}             Dispatches many UPDATE_COMPONENT actions
 */
/*#Removed4POS*/
/*const getInvitation = () => (dispatch, getState) => {
  const token = new ActionToken('step.getInvitation')

  const { step } = getState()

  const isReturnedToFirstStep = step.number === 1 && !!step.contactId

  if (
    !!step.contactId &&
    (isReturnedToFirstStep || (step.number > 1 && step.isUnderage === null))
  ) {
    dispatch(dealActionToken(token))

    return API.getInvitation(step.contactId).then(json => {
      return dispatch(invitationCallback(token, json))
    })
  }

  return Promise.resolve({})
}*/

/**
 * Reports the invitations to the signaler service
 *
 * @param  {Object} oldWidgets      The old widgets
 * @param  {Object} oldComponents   The old components
 * @param  {string} contactId       The actual contactId
 * @return {Function}               Dispatches a ACCEPTED_INVITATION action
 */
/*#Removed4POS*/
/*const acceptInvitation = (oldWidgets, oldComponents, contactId) => dispatch => {
  if (!!oldWidgets.SIGNALER) {
    const token = new ActionToken('step.acceptInvitation')

    dispatch(dealActionToken(token))

    const invitation = {
      contactId: contactId,
      codiceFiscale: oldComponents['CODICE_FISCALE-CF'].value,
      email: oldComponents['EMAIL-EMAIL'].value,
      phoneNumber: `${oldComponents['CELLULARE-PREF_CELLULARE'].value}${
        oldComponents['CELLULARE-NUM_CELLULARE'].value
      }`,
      promoCode:
        oldComponents['SIGNALER-PROMO_CODE'].status.indexOf('hidden') < 0
          ? oldComponents['SIGNALER-PROMO_CODE'].value
          : '',
      encryptedReporterId: oldComponents['SIGNALER-REFERRER'].value,
      campaignUrl: oldComponents['SIGNALER-CAMPAIGN_URL'].value
    }

    return API.acceptInvitation(invitation).then(json => {
      dispatch({
        type: ACCEPTED_INVITATION,
        widget: oldWidgets.SIGNALER
      })

      return dispatch(invitationCallback(token, json))
    })
  } else {
    return dispatch(getInvitation())
  }
}*/

/**
 * Components client-side validation
 * @return {Undefined}   nothing
 */
const validateStep = () => (dispatch, getState) => {
  const { components } = getState()
  Object.keys(components).forEach(k => {
    dispatch(
      validateComponent(k, {
        passTrough: false,
        evalBlanks: true,
        execLazy: true
      })
    )
  })
}

/**
 * Resumes an onboarding process
 * @public
 *
 * @param {Boolean} forClosedContract     Specifies if the otp has to be sent for an open or closed contract
 * @return {null}                         nothing
 */
export const sendResumeOtpSms = forClosedContract => (dispatch, getState) => {
  const token = new ActionToken('step.sendResumeOtpSms')

  dispatch(dealActionToken(token))
  API.sendResumeOtpSms(forClosedContract).then(json => {
    dispatch(handleServerErrors(json))
    const { step } = getState()

    if (!step.hasServerErrors) {
      dispatch(dealActionToken({ ...token, dispose: true }))
    }
  })
}

// 'stepCallbackSteps' for Selfie Implementation
export const stepCallbackSteps = (entities, json, product, oldWidgets, oldComponents) => (
  dispatch,
  getState
) => {

  const { step: oldStep } = getState()
  let invitationPromise = Promise.resolve({ data: {} })

  // added for making the contract list call aftetr the 7th step is loaded
      // if (
      //   getState().step.number === 7 &&
      //   product.prodCode === posProducts.prodAzienda
      // ) {
      //   API.request({
      //     endpoint: 'wgt/sign/contractlist'
      //   }).then(sBoxJson => {
      //     if (sBoxJson.status === 'success') {
      //       const contract = sBoxJson.data.contracts.filter(
      //         c => c.azioni === 'FIRMA'
      //       )[0]

      //       contract.url = `${process.env.API_ROOT}/wgt/utils/stampa/contract/${
      //         contract.stampeId
      //       }/${contract.barCode}.pdf`
      //       return { ...pJson, contract }
      //     }
      //   })
      // }

      /*#Removed4POS*/
      /*if (
        !!oldWidgets &&
        !!oldComponents &&
        oldStep.number !== getState().step.number
      ) {
        invitationPromise = invitationPromise.then(pJson => {
          return dispatch(
            acceptInvitation(
              oldWidgets,
              oldComponents,
              getState().step.contactId
            )
          ).then(nJson => {
            return { ...pJson, ...nJson }
          })
        })
      } else {
        invitationPromise = invitationPromise.then(pJson => {
          return dispatch(getInvitation()).then(nJson => {
            return { ...pJson, ...nJson }
          })
        })
      }*/ 
      if(!!entities.widgets["TITOLARE_EFFETTIVO"] 
      && !!entities.widgets["TITOLARE_EFFETTIVO"].status && 
      entities.widgets["TITOLARE_EFFETTIVO"].status[0]==='ignoreValidation' &&
      !!entities.components["TITOLARE_DATA-EFFETTIVO_SI"] && 
      entities.components["TITOLARE_DATA-EFFETTIVO_SI"].value==='' && 
      !!entities.components["TITOLARE_DATA-EFFETTIVO_NO"] && 
      entities.components["TITOLARE_DATA-EFFETTIVO_NO"].value==='' && 
      !!entities.components && 
      !!entities.components['SZ0025-SS0052_DM0097_RI0022'] && 
      !!entities.components['SZ0025-SS0052_DM0097_RI0023'] &&
      !!entities.components['SZ0025-SS0163_DM0503_RI0568'] &&
      !!entities.components['SZ0025-SS0163_DM0503_RI0569'] &&
      !!entities.components['TITOLARE_OWNER-EFFETTIVO_SI'] &&
      !!entities.components['TITOLARE_OWNER-EFFETTIVO_NO'] &&
      !!entities.components['TITOLARE_OWNER-LABEL']  && 
      !!entities.components['SZ0025-SS0163'] &&
      !!entities.components['SZ0025-SS0052'])
      {
        entities.components['SZ0025-SS0052_DM0097_RI0022'].status[0]='hidden';
        entities.components['SZ0025-SS0052_DM0097_RI0023'].status[0]='hidden';
        entities.components['SZ0025-SS0163_DM0503_RI0568'].status[0]='hidden';
        entities.components['SZ0025-SS0163_DM0503_RI0569'].status[0]='hidden';
        entities.components['TITOLARE_OWNER-EFFETTIVO_NO'].status[0]='hidden';
        entities.components['TITOLARE_OWNER-EFFETTIVO_SI'].status[0]='hidden'; 
        entities.components['TITOLARE_OWNER-LABEL'].status[0]='hidden'; 
        entities.components['SZ0025-SS0163'].status[0]='hidden'; 
        entities.components['SZ0025-SS0052'].status[0]='hidden'; 
      }
      
  invitationPromise = invitationPromise.then(invitationJson => {
    dispatch(
      updateAllWidgets(
        extendModel(entities.widgets, oldWidgets, {
          dispatch,
          step: json.step.number,
          product: product.prodCode,
          name: json.step.name,
          isWebCamEnabled: json.step.isWebCamEnabled
        })
      )
    )
    dispatch(
      updateAllComponents(
        extendModel(entities.components, oldComponents, {
          dispatch,
          widgets: entities.widgets,
          step: json.step.number,
          product: product.prodCode,
          name: json.step.name,
          isWebCamEnabled:json.step.isWebCamEnabled
        })
      )
    )
    
    //dispatch(updateStep(json.step))
    const { widgets, components, step /*, product*/ } = getState()
    if (
      json.step &&
      json.step.number === 5 &&
      product.prodCode === posProducts.prodAzienda &&
      step.userCounter === 0
    ) {
      json.step.titoWidgets = JSON.parse(JSON.stringify(widgets))
      json.step.titoComponents = JSON.parse(JSON.stringify(components))

      Object.keys(json.step.titoWidgets).forEach(k => {
        if (k && k === 'TITOLARE_DATA') {
          delete json.step.titoWidgets[k]
        }
        if (k === 'SZ0025' || k === 'CODICE_FISCALE' || k === 'DOCUMENTO' || k === 'NOME_COGNOME' || k === 'RESIDENZA') {
          json.step.titoWidgets[k].status = json.step .titoWidgets[k].status.filter(
            s => s !== 'hidden'
          )
        }
      })
      Object.keys(json.step.titoComponents).forEach(k => {
        if (k && k.startsWith('TITOLARE_DATA')) {
          delete json.step.titoComponents[k]
        } else {
          if (json.step.titoComponents[k].status[0] === 'hidden' && k !== 'CODICE_FISCALE-SESSO' && k !== 'CODICE_FISCALE-PROVINCIADINASCITA' && k !== 'CODICE_FISCALE-PROVINCIADINASCITA' && (k.startsWith('CODICE_FISCALE') || k.startsWith('DOCUMENTO') || k.startsWith('NOME_COGNOME') || k.startsWith('RESIDENZA'))) {
            json.step.titoComponents[k].status = json.step.titoComponents[k].status.filter(
              s => s !== 'hidden')
          }
          // if(json.step.titoComponents[k].active === 'false' && k !== 'CODICE_FISCALE-SESSO' && k !== 'CODICE_FISCALE-PROVINCIADINASCITA' && (k.startsWith('CODICE_FISCALE')|| k.startsWith('DOCUMENTO')||k.startsWith('NOME_COGNOME')|| k.startsWith('RESIDENZA')))
          // {
          //   json.step.titoComponents[k].active = true
          // }
          json.step.titoComponents[k].validations =
            components[k].validations
        }
      })
      // if(!!json.step.titoWidgets["TITOLARE_EFFETTIVO"] 
      // && !!json.step.titoWidgets["TITOLARE_EFFETTIVO"].status && 
      // json.step.titoWidgets["TITOLARE_EFFETTIVO"].status[0]==='ignoreValidation' &&
      // !!json.step.titoComponents["TITOLARE_DATA-EFFETTIVO_SI"] && 
      // json.step.titoComponents["TITOLARE_DATA-EFFETTIVO_SI"].value==='' && 
      // !!json.step.titoComponents["TITOLARE_DATA-EFFETTIVO_NO"] && 
      // json.step.titoComponents["TITOLARE_DATA-EFFETTIVO_NO"].value==='' && 
      // !!json.step.titoComponents && !!json.step.titoComponents['SZ0025-SS0052_DM0097_RI0022'] && 
      // !!json.step.titoComponents['SZ0025-SS0052_DM0097_RI0023'] &&
      // !!json.step.titoComponents['SZ0025-SS0163_DM0503_RI0568'] &&
      // !!json.step.titoComponents['SZ0025-SS0163_DM0503_RI0569'] &&
      // !!json.step.titoComponents['TITOLARE_OWNER-EFFETTIVO_SI'] &&
      // !!json.step.titoComponents['TITOLARE_OWNER-EFFETTIVO_NO'] &&
      // !!json.step.titoComponents['TITOLARE_OWNER-LABEL']  && 
      // !!json.step.titoComponents['SZ0025-SS0163'] &&
      // !!json.step.titoComponents['SZ0025-SS0052'])
      // {
      // json.step.titoComponents['SZ0025-SS0052_DM0097_RI0022'].status[0]='hidden';
      // json.step.titoComponents['SZ0025-SS0052_DM0097_RI0023'].status[0]='hidden';
      // json.step.titoComponents['SZ0025-SS0163_DM0503_RI0568'].status[0]='hidden';
      // json.step.titoComponents['SZ0025-SS0163_DM0503_RI0569'].status[0]='hidden';
      // json.step.titoComponents['TITOLARE_OWNER-EFFETTIVO_NO'].status[0]='hidden';
      // json.step.titoComponents['TITOLARE_OWNER-EFFETTIVO_SI'].status[0]='hidden'; 
      // json.step.titoComponents['TITOLARE_OWNER-LABEL'].status[0]='hidden'; 
      // json.step.titoComponents['SZ0025-SS0163'].status[0]='hidden'; 
      // json.step.titoComponents['SZ0025-SS0052'].status[0]='hidden'; 
      // }
      dispatch(updateStep(json.step))

      //MOVED THE CODE TO ELSE STATEMENT
      const TED = components['TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA']
      let nomeObj = TED && TED.values.find(w => w.description === "NOME")
      let cognomeObj = TED && TED.values.find(w => w.description === "COGNOME")
      let nome = nomeObj && nomeObj.value?nomeObj.value:''
      let cognome = cognomeObj && cognomeObj.value?cognomeObj.value:''
      const titoRawValue = TED && TED.rawValue
      const titoValue = titoRawValue && titoRawValue.titolare_effettivo
      if (titoValue && titoValue.length) {
        const userDetails = {
          id: step.userCounter,
          userWidgets: JSON.parse(JSON.stringify(widgets)),
          userComponents: JSON.parse(JSON.stringify(components)),
          NOME: nome,
          COGNOME: cognome
        }
        let titoUserValue = titoValue[userDetails.id]
        dispatch(getPrevTitolareUser(userDetails, titoUserValue))
        dispatch(addTitolareUserToObject(userDetails, step.userCounter))

        for (let i = 1; i < titoValue.length; i++) {
          //dispatch(addTitolareUser())
          step.userCounter = step.userCounter + 1
          const userD = {
            id: step.userCounter,
            userWidgets: JSON.parse(JSON.stringify(json.step.titoWidgets)),
            userComponents: JSON.parse(JSON.stringify(json.step.titoComponents))
          }
          let titoUserValue = titoValue[userD.id]
          dispatch(getPrevTitolareUser(userD, titoUserValue))
          dispatch(addTitolareUserToObject(userD, step.userCounter))
        }
        //dispatch({ type: USER_COUNTER })
      }
      //for retricting the user to get updated while coming back
      else {
        const userDetails = {
          id: step.userCounter,
          userWidgets: JSON.parse(JSON.stringify(widgets)),
          userComponents: JSON.parse(JSON.stringify(components)),
          NOME: nome,
          COGNOME: cognome
        }
        dispatch(addTitolareUserToObject(userDetails, step.userCounter))
      }
    }

    if (!!json.isOtpCallback) {
      dispatch(sendResumeOtpSms(!!json.isContractClosed))
    }

    // step 1

    // @todo remove this statement and use the new initialization methods instead
    /*#Removed4POS*/
    /*if (!!json.proof) {
      switch (json.proof.type) {
        case 'hype':
          if (getState().step.number === 1) {
            dispatch(decryptHypeProof(json.proof))
          }
          break
        case 'yoox':
          if (getState().step.number < 3 && product.flow === 'hypeyoox') {
            // @remarks product.flow check is necessary to trigger the decryption only on legacy init
            dispatch(decryptYooxProof(json.proof))
          }
          break
      }
    }

    if (
      !routing.locationBeforeTransitions.query.proof &&
      !routing.locationBeforeTransitions.query.proofType &&
      getState().step.number === 1
    ) {
      dispatch(updateCampaignUrl(routing.locationBeforeTransitions.search))
    }

    if (
      !!routing.locationBeforeTransitions.query.promoCode &&
      getState().step.number === 1
    ) {
      dispatch(
        updatePromoCode(
          routing.locationBeforeTransitions.query.promoCode,
          true
        )
      )
    }*/

    if (!!widgets.EMAIL) {
      if (widgets.EMAIL.status.indexOf('readonly') > -1) {
        const emailConfirmComponent = components['EMAIL-CONFERMA_EMAIL']
        const mobileConfirmComponent =
          components['CELLULARE-CONFERMA_NUM_CELLULARE']
        const signaler = widgets.SIGNALER
        const mobileWidget = widgets.CELLULARE

        signaler.status = union(signaler.status, ['hidden'])
        dispatch(updateWidget(signaler.name, signaler))
        emailConfirmComponent.status = union(emailConfirmComponent.status, [
          'hidden'
        ])
        dispatch(
          updateComponent(emailConfirmComponent.id, emailConfirmComponent)
        )
        mobileConfirmComponent.status = union(
          mobileConfirmComponent.status,
          ['hidden']
        )
        dispatch(
          updateComponent(mobileConfirmComponent.id, mobileConfirmComponent)
        )
        mobileWidget.status = union(mobileWidget.status, ['readonly'])
        dispatch(updateWidget(mobileWidget.name, mobileWidget))

        if (
          (!getState().step.auth || !getState().step.auth.tokenId) &&
          !getState().step.isParent
        ) {
          dispatch(setIsParent())
        }
      }
    }

    /*#Removed4POS*/
    /*if (!!widgets.SIGNALER) {
      if (!!getState().step.contactId) {
        // gone back to first step
        if (invitationJson.lastData.campaignUrl) {
          dispatch(
            updateComponent('SIGNALER-CAMPAIGN_URL', {
              value: invitationJson.lastData.campaignUrl
            })
          )
        }

        if (invitationJson.lastData.encryptedReporterId) {
          dispatch(
            updateComponent('SIGNALER-REFERRER', {
              value: invitationJson.lastData.encryptedReporterId
            })
          )
        }

        if (invitationJson.lastData.promoCode) {
          dispatch(
            updateComponent('SIGNALER-PROMO_CODE', {
              value: invitationJson.lastData.promoCode
            })
          )
        }

        if (
          !!getState().components['SIGNALER-PROMO_CODE'].value &&
          widgets.SIGNALER.status.indexOf('hidden') < 0
        ) {
          // @hack the correct instructions should be the one commented below but for some reason doesn't work as expected
          document.getElementById('SIGNALER-HAS_PROMO_CODE_YES').click()

          // dispatch(updateComponent('SIGNALER-HAS_PROMO_CODE_YES', { value: !!getState().components['SIGNALER-PROMO_CODE'].value ? 'selected' : components['SIGNALER-HAS_PROMO_CODE_YES'].value }))
          // dispatch(updateComponent('SIGNALER-HAS_PROMO_CODE_NO', { value: !getState().components['SIGNALER-PROMO_CODE'].value ? 'selected' : components['SIGNALER-HAS_PROMO_CODE_NO'].value }))
        }
      }

      if (product.partnership === 'HYPE' && product.convention === 'YOOX') {
        dispatch(
          updateWidget('SIGNALER', {
            status: union(widgets.SIGNALER.status, ['hidden'])
          })
        )
      }

      if (
        product.partnership === 'HYPE' &&
        product.convention === 'ADECCO'
      ) {
        dispatch(
          updateWidget('SIGNALER', {
            status: union(widgets.SIGNALER.status, ['hidden'])
          })
        )
        if (!!widgets.JOLLY) {
          dispatch(
            updateComponent('JOLLY-JOLLY_INPUT', {
              value: product.convention
            })
          )
        }
      }
    }

    if (!!widgets.CELLULARE) {
      if (
        product.partnership === 'HYPE4TIM' &&
        !!components['CELLULARE-CONFERMA_NUM_CELLULARE']
      ) {
        dispatch(
          updateComponent('CELLULARE-CONFERMA_NUM_CELLULARE', {
            status: [
              ...new Set([
                ...components['CELLULARE-CONFERMA_NUM_CELLULARE'].status,
                'hidden'
              ])
            ]
          })
        )
      }
    }*/

    // step 2

    if (!!widgets.VERIFICA_DATI_DA_CF) {
      if (
        !!components['VERIFICA_DATI_DA_CF-PROVINCIA'] &&
        components['VERIFICA_DATI_DA_CF-PROVINCIA'].value !== 'EE' &&
        !!components['CITTADINANZA-CITTADINANZA']
      ) {
        components['CITTADINANZA-CITTADINANZA'].initialValue = 'ITALIA'
      }
      // else {
      //   components['CITTADINANZA-CITTADINANZA'].initialValue =
      //     components['VERIFICA_DATI_DA_CF-CITTA'].value
      // }
    }

    // step 3

    if (!!widgets.TIPOLOGIA_CARTA) {
      if (!!getState().step.isParent) {
        dispatch(
          updateComponent('TIPOLOGIA_CARTA-CARTA_VIRTUALE', {
            value: 'selected'
          })
        )
        dispatch(
          updateComponent('TIPOLOGIA_CARTA-CARTA_FISICA', { value: '' })
        )
      }
      /*#Removed4POS*/
      /*if (product.partnership === 'HYPE' && product.convention === 'YOOX') {
        dispatch(
          updateWidget('TIPOLOGIA_CARTA', {
            status: union(widgets.TIPOLOGIA_CARTA.status, ['hidden'])
          })
        )
      }

      if (product.partnership === 'HYPE4TIM') {
        if (!getState().step.isParent) {
          dispatch(
            updateWidget('TIPOLOGIA_CARTA', {
              groupTitle: 'Carta virtuale TIMpersonal'
            })
          )

          dispatch(
            updateWidget('VERIFICA_EMAIL_EXTRA', {
              status: widgets.VERIFICA_EMAIL_EXTRA.status.filter(
                s => s !== 'hidden'
              )
            })
          )
          dispatch(
            updateComponent('VERIFICA_EMAIL_EXTRA-TYPE_VALUE', {
              value: getState().step.email
            })
          )
        }

        dispatch(
          updateComponent('TIPOLOGIA_CARTA-CARTA_VIRTUALE', {
            status: union(
              components['TIPOLOGIA_CARTA-CARTA_FISICA'].status,
              ['readonly', 'reallyreadonly']
            ),
            cleanName: '',
            description:
              'La carta virtuale TIMpersonal ti consente di effettuare acquisti online e nei negozi abilitati in totale sicurezza, scambiare denaro tra amici, ricevere bonifici e tanto altro. Una volta attivata, potrai poi richiedere anche la carta fisica se lo desideri.'
          })
        )
        dispatch(
          updateComponent('TIPOLOGIA_CARTA-CARTA_FISICA', {
            status: union(
              components['TIPOLOGIA_CARTA-CARTA_FISICA'].status,
              ['hidden']
            )
          })
        )
      }

      if (product.convenzione === 'HERBALIFE') {
        if (!getState().step.isParent) {
          dispatch(
            updateWidget('TIPOLOGIA_CARTA', {
              groupTitle: 'Carta virtuale Herbalife'
            })
          )
        }

        dispatch(
          updateComponent('TIPOLOGIA_CARTA-CARTA_VIRTUALE', {
            status: union(
              components['TIPOLOGIA_CARTA-CARTA_FISICA'].status,
              ['readonly', 'reallyreadonly']
            ),
            cleanName: '',
            description:
              'La carta virtuale Herbalife ti consente di effettuare acquisti online e nei negozi abilitati in totale sicurezza, scambiare denaro tra amici, ricevere bonifici e tanto altro. Una volta attivata, potrai poi richiedere anche la carta fisica se lo desideri.'
          })
        )
        dispatch(
          updateComponent('TIPOLOGIA_CARTA-CARTA_FISICA', {
            status: union(
              components['TIPOLOGIA_CARTA-CARTA_FISICA'].status,
              ['hidden']
            )
          })
        )
      }*/
    }

    /*if (!!widgets.RIF_SPEDIZIONE_CARTA) {
      if (
        product.partnership === 'HYPE4TIM' ||
        !!getState().step.isParent
      ) {
        dispatch(
          updateWidget('RIF_SPEDIZIONE_CARTA', {
            status: [
              ...new Set([...widgets.RIF_SPEDIZIONE_CARTA.status, 'hidden'])
            ]
          })
        )
      }
    }*/

    getStoredState().updateSession(
      getState().step.contactId,
      getState().step.number,
      !!getState().step.isParent
    )

    const reachedStep = getStoredState().getSessionStep(
      getState().step.contactId,
      !!getState().step.isParent
    )

    if (!!widgets.DOCUMENTAZIONE) {
      dispatch(
        tweakAgreement({
          widget: widgets.DOCUMENTAZIONE,
          force: reachedStep <= 3,
          hide: true
        })
      )
    }

    // if (!!widgets.CRONISTORIA) {
    //   dispatch(
    //     tweakAgreement({
    //       widget: widgets.CRONISTORIA,
    //       // force: reachedStep <= 3,
    //       hide: false
    //     })
    //   )
    // }

    // if (!!widgets.DATI_SENSIBILI) {
    //   dispatch(
    //     tweakAgreement({
    //       widget: widgets.DATI_SENSIBILI,
    //       force: reachedStep <= 3,
    //       hide: !!getState().step.isUnderage,
    //       forceValue: !!getState().step.isUnderage ? 'selected' : '',
    //       description:
    //         !!getState().step.isParent &&
    //         'Ti chiediamo il consenso al trattamento dei dati sensibili sia per te che per il minore. IMPORTANTE: non richiediamo e non trattiamo di nostra iniziativa i “dati sensibili” se non per dare esecuzione alla disposizione delle operazioni. Ci teniamo a precisare che NON UTILIZZEREMO QUESTI DATI IN ALTRO MODO.'
    //     })
    //   )
    // }

    // if (!!widgets.PROFILAZIONE) {
    //   dispatch(
    //     tweakAgreement({
    //       widget: widgets.PROFILAZIONE,
    //       force: reachedStep <= 3,
    //       hide: false
    //     })
    //   )
    // }

    // if (!!widgets.PROMOZIONE) {
    //   dispatch(
    //     tweakAgreement({
    //       widget: widgets.PROMOZIONE,
    //       force: reachedStep <= 3,
    //       hide: !!getState().step.isUnderage,
    //       forceValue: !!getState().step.isUnderage ? 'selected' : '',
    //       description:
    //         !!getState().step.isParent &&
    //         'Ti chiediamo il consenso per il trattamento dei tuoi dati e di quelli del minore da parte di Axerve S.p.A., da parte di una Società del Gruppo Sella oppure da parte di società terze nominate responsabili esterne del trattamento per l’offerta di prodotti finanziari del Gruppo Sella e prodotti e servizi di terzi, per la gestione o/e il monitoraggio dei movimenti, anche ai fini antifrode, o per la realizzazione e l’invio di promozioni ed offerte create “su misura” per te, sia direttamente che tramite società terze.'
    //     })
    //   )
    // }

    // if (!!widgets.PROMOZIONE_TERZI) {
    //   dispatch(
    //     tweakAgreement({
    //       widget: widgets.PROMOZIONE_TERZI,
    //       force: reachedStep <= 3,
    //       hide: false
    //     })
    //   )
    // }

    if (
      !!widgets.DOCUMENTO_2 &&
      !!(
        components['DOCUMENTO_2-BOLLETTA'].active &&
        components['DOCUMENTO_2-BUSTA_PAGA'].active &&
        components['DOCUMENTO_2-CARTA_IDENTITA'].active &&
        components['DOCUMENTO_2-ESTRATTO_CONTO'].active
      )
    ) {
      dispatch(
        updateComponent('DOCUMENTO_2-DOCR_UPLOAD', {
          active: false,
          status: ['hidden']
        })
      )
      const wdoc2UpdatedBody = {
        status: []
      }
      dispatch(updateWidget('DOCUMENTO_2', wdoc2UpdatedBody))
    }

    // step 4

    if (!!widgets.MOD_IDENTIFICAZIONE) {
      if (!!getState().step.isUnderage || !!md.mobile()) {
        widgets.MOD_IDENTIFICAZIONE.components.forEach(k => {
          if (components[k].type === 'radio')
            dispatch(updateComponent(k, { type: 'hidden' }))
        })
      }
    }

    if (
      !!widgets.DOCUMENTO_2 &&
      !!components['DOCUMENTO_2-TIPO_DOCUMENTO'].active
    ) {
      const wdoc2UpdatedBody = {
        status: widgets.DOCUMENTO_2.status.filter(s => s !== 'hidden')
      }

      if (
        !!components['DOCUMENTO_2-PERMESSO_SOGGIORNO'] &&
        !!components['DOCUMENTO_2-PERMESSO_SOGGIORNO'].active
      ) {
        wdoc2UpdatedBody.groupTitle = 'Permesso di soggiorno'

        dispatch(
          updateComponent('DOCUMENTO_2-PERMESSO_SOGGIORNO', {
            value: 'selected'
          })
        )
      }

      dispatch(updateWidget('DOCUMENTO_2', wdoc2UpdatedBody))
    }
    /*  if (!!widgets.TERMINA_PROCEDURA) {
         dispatch(
           updateComponent(
             'TERMINA_PROCEDURA-CONTRATTO',
             {
               link: {
                 ...components['TERMINA_PROCEDURA-CONTRATTO'].link
                 // stampeId: invitationJson.contract.stampeId,
                 // barCode: invitationJson.contract.barCode,
                 // url: invitationJson.contract.url
               }
             },
             { bypassValidation: true }
           )
         )

         if (!!getState().step.isParent) {
           dispatch(
             updateComponent(
               'TERMINA_PROCEDURA-LABEL',
               { value: 'Per completare la richiesta manca pochissimo!' },
               { bypassValidation: true }
             )
           )
           dispatch(
             updateComponent(
               'TERMINA_PROCEDURA-CONTRATTO',
               {
                 value:
                   'Proseguendo dichiaro di aver letto e accettato il §link§ del minorenne ed attesto che sia fiscalmente residente esclusivamente in Italia (*)'
               },
               { bypassValidation: true }
             )
           )
           dispatch(
             updateComponent(
               'TERMINA_PROCEDURA-MODULO',
               { status: ['hidden'] },
               { bypassValidation: true }
             )
           )
           dispatch(
             updateComponent(
               'TERMINA_PROCEDURA-RESIDENZA_ITA',
               {
                 value:
                   'Nel caso il minorenne abbia altre residenze fiscali oltre a quella italiana scrivici §link§' //contattaci telefonicamente allo §phone§ oppure
               },
               { bypassValidation: true }
             )
           )
         }

         if (!!getState().step.isUnderage) {
           dispatch(
             updateComponent(
               'TERMINA_PROCEDURA-CONTRATTO',
               {
                 value:
                   'Qui trovi la copia del §link§, clicca su continua per concludere.'
               },
               { bypassValidation: true }
             )
           )
           dispatch(
             updateComponent(
               'TERMINA_PROCEDURA-MODULO',
               { status: ['hidden'] },
               { bypassValidation: true }
             )
           )
           dispatch(
             updateComponent(
               'TERMINA_PROCEDURA-RESIDENZA_ITA',
               { status: ['hidden'] },
               { bypassValidation: true }
             )
           )
           dispatch(
             updateComponent(
               'TERMINA_PROCEDURA-RESIDENZA_ITA_SPEC',
               { status: ['hidden'] },
               { bypassValidation: true }
             )
           )
         }
       } */

    // if (!oldWidgets || !oldComponents) {
    Object.keys(getState().components).forEach(k => {
      const component = getState().components[k]
      if (component.hasOwnProperty('autofill')) {
        dispatch(autoFillDependantComponents(k))
      }
      if (component.hasOwnProperty('trigger')) {
        for (const comp of component.trigger) {
          if (comp.type === 'call' && comp.fn) {
            dispatch(invokeMethod(comp, component))
          }
        }
      }
    })
    // }

    // scrolls to top on step change or to the firs invalid component
    if (oldStep.number !== getState().step.number) {
      window.scrollTo(0, 0)
    } else {
      scrollToFirstInvalidComponent(components)
    }

    dispatch(
      rewriteRoute(
        !!invitationJson.lastData
          ? invitationJson.lastData.campaignUrl
          : null
      )
    )
  })

}

/**
 * Handles a step change callback
 * @param  {Object} token                 The ActionToken
 * @param  {Object} json                  The step data
 * @param  {Object} oldWidgets            The optional old step's widgets
 * @param  {Object} oldComponents         The optional old step's components
 * @return {null}                         nothing
 */
export const stepCallback = (token, json, oldWidgets, oldComponents) => (
  dispatch,
  getState
) => {
  const { step: oldStep, product } = getState()
  let invitationPromise = Promise.resolve({ data: {} })

  dispatch(handleServerErrors(json))
  let stepWidgets = json.step && json.step.widgets ? json.step.widgets : []
  const widgets_ = JSON.parse(JSON.stringify(stepWidgets))
  let staticWidgets = []
  let staticOwnerWidgets = []
  let staticPosPlanWidgets=[]
  /* TODO: add product code check along with step number */
  
  //Enable OTP Text Box for all the product flows
   if(stepWidgets.length && json.step && json.step.number===1) //&& product.prodCode !== posProducts.prodPersonaFisica)
  {
    stepWidgets.find(w=>w.name==='CELLULARE').components.map(c=>{
      if(c.name==='CODICE_CELLULARE')
      {
        c.active=true
      }
    

    })
  }
  //Move component from 1st to 3rd Step Ditta individuale flow (Test-Env)
  if(product.prodCode === posProducts.prodDittaInd && (json.step && json.step.number===3))
  {
    stepWidgets.find(w=>w.name==='DENOMINAZIONE_AZIENDA').components.map(c=>{
      if(c.name==='DENOMINAZIONE')
      {
        c.staticDescFlag=true
      }

    })
  }

  
  //POS Status based 'VAT IDENTIFICATION CERTIFICATE' widget action - March16-2020 
  if(product.prodCode === posProducts.prodDittaInd && (json.step && json.step.number===6))
  {
    var genericoWidget = stepWidgets.find(w=>w.name==='DOCUMENTO_GENERICO');
    if(genericoWidget.status.length > 0 && genericoWidget.status[0] === "hidden" ){ 
         genericoWidget.components = []
    }
  }

  
  if(product.prodCode !== posProducts.prodPersonaFisica && json.step && (json.step.number===3)) {
    stepWidgets.find(w=>w.name==='TELEFONO_FISSO').components.map(c=>{
      if(c.name==='NUMERO')
      {
        c.status = []
      }

    })
  }

  if(stepWidgets.length && json.step && json.step.number === 5 && product.prodCode === posProducts.prodAzienda)
  {

    let titolareEffectivoData = stepWidgets.find(w=>w.name==='TITOLARE_EFFETTIVO').components.find(x =>x.name === 'TITOLARE_EFFETTIVO_DATA');
    if(!!titolareEffectivoData.rawValue)
    {
      stepWidgets.find(w=>w.name==='TITOLARE_EFFETTIVO').components.find(x =>x.name === 'TITOLARE_EFFETTIVO_DATA').rawValue.titolare_effettivo.map(m => {     
          if(!!m.residenza)
              m.residenza.nazione = (!!m.residenza.nazione || m.residenza.nazione === '') ? 'ITALIA' : m.residenza.nazione

        if (!m.residenza) {
          // delete m.residenza
          m.residenza = { nazione: 'ITALIA' }
        }   
      })
    }    			 
  }
  
  //Remove Pre Compiled Code in Step 2
  if(json.step && json.step.number===2)
  {
    // stepWidgets.find(w=>w.name==='VERIFICA_DATI_DA_CF').components.map(c=>{
    // })
    stepWidgets.map(w=>{
      if(w.name==='VERIFICA_DATI_DA_CF')
      {
        w.status=['hidden']
      }
    })

  }
  //Add Document Rules Component
    const DocumentoStepWidget = JSON.parse(
       JSON.stringify(getDocumentoRulesComponent())
    )
    if(stepWidgets.filter(w=>w.name==="DOCUMENTO").length>0)
    {
      let DocumentoWidget = stepWidgets.filter(w => w.name === 'DOCUMENTO')
      DocumentoWidget[0].components=[...DocumentoWidget[0].components,...DocumentoStepWidget.widgets[0].components]
    }

    if(stepWidgets.filter(w=>w.name==="DOCUMENTO_2").length>0)
    {
      let SecondDocumentoWidget = stepWidgets.filter(w => w.name === 'DOCUMENTO_2')
      SecondDocumentoWidget[0].components=[...SecondDocumentoWidget[0].components,...DocumentoStepWidget.widgets[1].components]
    }

  //End Document Rules
  /// For Ditta individuale Flow
  if(product.prodCode === posProducts.prodDittaInd && json.step && json.step.number === 4 )
  {  
    if(stepWidgets.filter(w=>w.name==="SETTORE_ATTIVITA_AZIENDA").length>0)
    {
      let DocumentoWidget = stepWidgets.filter(w => w.name === 'SETTORE_ATTIVITA_AZIENDA');
      DocumentoWidget[0].components=[...DocumentoWidget[0].components,...Model.WIDGETS.SETTORE_ATTIVITA_AZIENDA_COMP.components]  
    }
  }

  //Selfie Issue not showing selfie image – Azienda  /  Camera setting issue - Ditta flow (step 6)
  if(json.step && (
    (product.prodCode === posProducts.prodAzienda && json.step.number === 2)
      || (product.prodCode === posProducts.prodDittaInd && json.step.number === 6) 
      || (product.prodCode === posProducts.prodPersonaFisica && json.step.number === 5)
  ))
  {
    if(!!stepWidgets.find(w=>w.name==='MOD_IDENTIFICAZIONE').components &&
        !!stepWidgets.find(w=>w.name==='MOD_IDENTIFICAZIONE').components.find(w=>w.name==='SELFIE_1_DOCUMENTO') &&
        !!stepWidgets.find(w=>w.name==='MOD_IDENTIFICAZIONE').components.find(w=>w.name==='SELFIE_1_DOCUMENTO').status &&
        stepWidgets.find(w=>w.name==='MOD_IDENTIFICAZIONE').components.find(w=>w.name==='SELFIE_1_DOCUMENTO').status[0] === 'selected' 
         //&& !!document.getElementById("MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO")
        )
        {
          stepWidgets.find(w=>w.name==='MOD_IDENTIFICAZIONE').components.map(c=>{
              if(c.name==='SELFIE_1_DOCUMENTO')
              {
                c.value = 'selected'
              }
           })

         //setTimeout(() => { document.getElementById('MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO').click() }, 500);      
        }
    else {
      stepWidgets.find(w=>w.name==='MOD_IDENTIFICAZIONE').components.map(c=>{
              if(c.name==='2_DOCUMENTI')
              {
                c.value = 'selected'
              }
          })
    }
  }

if(json.step && json.step.number===3 && (json.step.name.toUpperCase()==="I DATI DELL'AZIENDA" || json.step.name.toUpperCase()==="LA TUA AZIENDA"))
{
  const PECAddressWidget = JSON.parse(
    JSON.stringify(getPECAddressComponent())
  )
  let PECStepwidget = stepWidgets.filter(w => w.name === 'PEC')
  PECStepwidget[0].components=[...PECStepwidget[0].components,...PECAddressWidget.widgets[0].components]
}
// if(json.step && json.step.number!==1)
// {
//    staticPosPlanWidgets = JSON.parse(
//     JSON.stringify(getPosPlanComponent())
//   )
//   staticPosPlanWidgets.widgets[0].components[0].fetchPosPlan = {
//     url:'OnboardRequestDetails/FetchPOSPlan', //'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/FetchPromoCode',//'https://172.17.4.63/magtek/OnboardRequestDetails/FetchPromoCode',
//     body: {
//       GUID: json.step.guid
//     },
//     mappingEvent: 'FetchPOSPlan'
//   }
//   stepWidgets = [
//     ...stepWidgets,...staticPosPlanWidgets.widgets]
// }


  if (
    stepWidgets.length &&
    json.step &&
    json.step.number === 5 &&
    product.prodCode === posProducts.prodAzienda
  ) {
    staticWidgets = TitolareStatic.getTitolareEffettivoComponent()
    staticOwnerWidgets = TitolareStatic.getTitolareStaticComponent()    
    const filteredwidgets = stepWidgets.filter(
      tw => tw.name === 'TITOLARE_EFFETTIVO'
    )
    if (filteredwidgets && filteredwidgets[0]) {
      const titolareJson = filteredwidgets[0].components[0].values.filter(
        tc => tc.description === 'QUESTIONARIO_PEP'
      )
      if (titolareJson) {
        const config = {
          data: titolareJson[0].jsonString,
          isSavePG: false,
          method: 'Titolare_Effettivo'
        }
        const DocumentoStepWidget = JSON.parse(
          JSON.stringify(getDocumentoRulesComponent())
       )
       if(staticWidgets.widgets.filter(w=>w.name==="DOCUMENTO").length>0)       {
         let DocumentoWidget = staticWidgets.widgets.filter(w => w.name === 'DOCUMENTO')
         DocumentoWidget[0].components=[...DocumentoWidget[0].components,...DocumentoStepWidget.widgets[0].components]
       }
        const parsedWidgets = dispatch(parseQuestionarioWidgets(null, config))
        stepWidgets = [
          ...stepWidgets,
          ...staticWidgets.widgets,
          ...parsedWidgets,
          ...staticOwnerWidgets.widgets,
        ]
      }
    }
  }
  if(json.step)
  {
     staticPosPlanWidgets = JSON.parse(
      JSON.stringify(getPosPlanComponent())
    )
    staticPosPlanWidgets.widgets[0].components[0].fetchPosPlan = {
      url:'OnboardRequestDetails/FetchPOSPlan', //'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/FetchPromoCode',//'https://172.17.4.63/magtek/OnboardRequestDetails/FetchPromoCode',
      body: {
        GUID: json.step.guid
      },
      mappingEvent: 'FetchPOSPlan'
    }
    stepWidgets = [
      ...stepWidgets,...staticPosPlanWidgets.widgets]
      //stepWidgets.components=[...stepWidgets.components,...staticPosPlanWidgets.widgets.components[0]]
  }
  if (stepWidgets.length && json.step.last) {
    json.step.disableButton = true

    const widgetCode = stepWidgets
      .filter(
        w =>
          w.name ===
          'ATTIVA_REVOCA_FIRMA' /*  || w.name == 'TERMINA_PROCEDURA' */
      )
      .map(w => w.code)
    const filteredwidgets = stepWidgets.filter(
      w => w.name === 'FLOW_BAR' /*  || w.name == 'TERMINA_PROCEDURA' */
    )
    const filteredwidgets_ = widgets_.filter(
      w => w.name === 'FLOW_BAR' /*  || w.name == 'TERMINA_PROCEDURA' */
    )

    stepWidgets = [...filteredwidgets]
    dispatch(updateDiFarmaComponent(filteredwidgets_, json))
    // widgets = filteredwidgets
  }
 
  //widget_.components = [].concat(widgets.components)
  if (!getState().step.hasServerErrors) {
    const { entities } = normalize(stepWidgets, widgetListSchema)

    if (!!getStoredState().authenticated) {
      json.step.auth = { tokenId: '-' }
    }

    json.step.widgets_ = widgets_
    const PRODUCT_PLUGIN = widgets_.find(w => w.name === 'PRODUCT_PLUGIN')
    if (PRODUCT_PLUGIN && PRODUCT_PLUGIN.code) {
      json.step.config = json.step.config || {}
      json.step.config.widget = json.step.config.widget || {}
      json.step.config.widget.PRODUCT_PLUGIN = {
        code: PRODUCT_PLUGIN.code,
        components: JSON.parse(JSON.stringify(PRODUCT_PLUGIN.components))
      }
    }
   
    // let invitationPromise = Promise.resolve({ data: {} })
    dispatch(updateStep(json.step))

    //Changes In Selfie Implementation
    if (json.step && (!!json.step.number || !!json.step.name)) {

      //To check the system has webcam or not
      if (
        ((product.prodCode === posProducts.prodPersonaFisica || 
          product.prodCode === posProducts.prodDittaInd) && 
          json.step.name === 'Identificati') ||
        (product.prodCode === posProducts.prodAzienda && json.step.name === 'Completa i tuoi dati')
      )
      {

        navigator.getUserMedia = (navigator.getUserMedia || navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia || navigator.msGetUserMedia)

        if (navigator.getUserMedia) {
          navigator.getUserMedia({ video: true },
            function (stream) {
              //when webcam is enabled in browser
              json.step.isWebCamEnabled = true
              dispatch(stepCallbackSteps(entities, json, product, oldWidgets, oldComponents))
            },
            function (e) {
              //when webcam in disabled in browser
              json.step.isWebCamEnabled =false
              dispatch(stepCallbackSteps(entities, json, product, oldWidgets, oldComponents))
            })
        }else{
          //If webcam not available
          dispatch(stepCallbackSteps(entities, json, product, oldWidgets, oldComponents))  
        }
      } else{
        //Normal flow dont need to check the webcam
        dispatch(stepCallbackSteps(entities, json, product, oldWidgets, oldComponents))
      }      
      
    }

    return invitationPromise.then(() => {
      dispatch(dealActionToken({ ...token, dispose: true }))
      if (oldStep.number !== getState().step.number) {
        dispatch(pushAnalytics())
      }

      //Selfie Issue not showing selfie image – Azienda 
      else if (!!oldStep &&                   
        !!getState() && 
        !!getState().step &&
        !!getState().step.widgets_
       &&
       (oldStep.number === 2 && product.partnership === posProducts.prodAzienda)
       &&
       (
         (!!getState().step.widgets_.find(w=>w.name==='CRIF').errorMessage.length > 0 )
         ||
         (!!oldStep.widgets_ 
           && !!oldStep.widgets_.find(w=>w.name==='SELFIE')
           && !!oldStep.widgets_.find(w=>w.name==='SELFIE').components
           && !!oldStep.widgets_.find(w=>w.name==='SELFIE').components.find(c=>c.name === "CHECK_OCR")
           && !!document.getElementById("MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO")
           && !!document.getElementById("MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO").value
           && document.getElementsByName('SELFIE-SELFIE_UPLOAD').length > 0
         )
      )){
           setTimeout(() => {
             document.getElementById("MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO").click()
           }, 1000); 
         
           let CrifComponent = getState().step.widgets_.find(w=>w.name==='CRIF')  
           if(!!CrifComponent.errorMessage.length > 0 ) 
           {
             let errMessage = CrifComponent.errorMessage[0]
             alert(errMessage)                       
           }                         
     }
    
    })
  }
}

/**
 * Prepares the start payload before calling the startProcess api
 * @param  {string} partnership     partnership code
 * @param  {string} convention      convention code
 * @param  {string} proof           an initi
 * @return {Promise}                Promise
 */
const startProcessWorker = (partnership, convention, proof, location) => (
  dispatch,
  getState
) => {
  let startJson

  const {
    routing: { locationBeforeTransitions: { query: initQuery } }
  } = getState()

  const federationPromise =
    partnership === 'HYPE4TIM' && !!Object.keys(initQuery).indexOf('code') > -1
      ? API.getTimUserInfo(initQuery)
      : Promise.resolve(!!proof ? proof.value : undefined)

  // @mock
  // const federationPromise =
  //   partnership === 'HYPE4TIM' && !!Object.keys(initQuery).indexOf('code') > -1
  //     ? Promise.resolve({
  //         responseCode: '000',
  //         responseDescr: 'Operation Successfully Completed',
  //         data: {
  //           userInfo: {
  //             sub:
  //               'acr:WNFVtapqjPhduvRTPSIkv3jD5KhRFTQMtXjOGQ9UAMMx7SofUIuiYqTUuF47rqDFegm3+kR5Xx+KW6N2MCaih/MqfWvtFV8DzdGNJH54AX7Pd6Yx3Q7J2igbRUE8DHHpI5fNMrpc+0UrnZRbHz+L3atiljnqF4I6n6pV/Dljxg6Q9gf6dy4tVNnHKi1uL9TdJpnBR6gNqPBAdhF3MgONfVOVU7ZbWIudg7Py3SEctKsc7BlSlXQ8n8Cx+v9xmUmNyPbHcH/M0uYe15ibGZ7k4l7bXPwuGLpA1FQqEOzbnaMbAZRwDemzgnbi7XXYlHNYG9XxNmU0OI1VrIV5dcG+mQ==;type=STAT;ncc=22201',
  //             name: 'Mario Rossi',
  //             given_name: 'Mario',
  //             family_name: 'Rossi',
  //             x_fiscal_code_tim: 'RSSMRA89A01E472I',
  //             phone_number: '3333333333'
  //           }
  //         }
  //       })
  //     : Promise.resolve(undefined)

  return federationPromise.then(thirdPartyData => {
    let userInfo

    if (partnership === 'HYPE4TIM') {
      if (!!thirdPartyData) {
        if (thirdPartyData.responseCode === '000') {
          userInfo = JSON.stringify(thirdPartyData.data.userInfo)
        } else {
          return Promise.reject({ ...thirdPartyData, type: 'tim-unauthorized' })
        }
      } else {
        return Promise.reject({ type: 'tim-unauthorized' })
      }
    } else {
      userInfo = thirdPartyData
    }

    return API.startOnboarding(partnership, convention, userInfo)
      .then(json => {
        startJson = json
        if (!!startJson && !!startJson.step && startJson.step.number === 1) {
          const requestbody = {}
          requestbody.Guid = startJson.step.guid
          requestbody.plan = location.query && location.query.plan
          // API.insertGUID(requestbody).then(json => {
          //   console.log(json)
          // })

        }
        return API.getProductInfo()
      })
      .then(jsonPc2 => {
        dispatch(handleServerErrors(jsonPc2))
        const { step } = getState()
        if (!step.hasServerErrors) {
          dispatch(updateProduct(jsonPc2.data))
        }
        return startJson
      })
  })
}

/**
 * Starts the onboarding process
 * @public
 * @param  {string} partnership     partnership code
 * @param  {string} convention      convention code
 * @param  {Object} proof           The encrypted third party data container
 * @param  {boolean} reboot           reboot
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
export const startProcess = ({ partnership, convention, proof, reboot, location }) => (
  dispatch,
  getState
) => {
  const token = new ActionToken('step.startProcess')

  const {
    routing: { locationBeforeTransitions: { query: initQuery } }
  } = getState()

  /**
   * @remarks
   * no need to dispatch a dealActionToken action here because this is the initialization action.
   * DON'T DO IT otherwisethe App container will be rendered before the props are provided,
   * the result will be an awful error.
   */

  return API.getProductInfo()
    .then(jsonPc => {
      if (
        jsonPc.status !== 'bad_request' &&
        jsonPc.data.prodCode === partnership // @remarks keep this condition to avoid breaking changes on legacy flows
        /*(|| jsonPc.data.properties[jsonPc.data.prodCode].partnership ===
            partnership) &&
        jsonPc.data.properties[jsonPc.data.prodCode].convenzione ===
          convention &&
        !(partnership === 'HYPE4TIM' && !!initQuery.code)*/
      ) {
        dispatch(updateProduct(jsonPc.data))
        return API.getNextStep()
          .then(json => {
            if (json.status === 'success' && !!json.step) {
              return json
            } else throw json
          })
          .catch(json => {
            if (
              (json.status === 'error' &&
                json.message.indexOf('invoke start api') > -1) ||
              (json.status === 'success' && !json.step)
            ) {
              return dispatch(
                startProcessWorker(partnership, convention, proof, location)
              )
            } else {
              return json
            }
          })
      } else {
        return dispatch(startProcessWorker(partnership, convention, proof, location))
      }
    })
    .then(json => {
      if (!!proof) {
        json.proof = proof
      }

      const { components } = getState()

      dispatch(stepCallback(token, json)).then(() => {
        if (!!reboot) {
          Object.keys(components).forEach(k => {
            const updatedBody = {
              value: components[k].value
            }

            if (k === 'SIGNALER-PROMO_CODE') {
              updatedBody.value = ''
              updatedBody.redirectRequired = false
            }

            dispatch(updateComponent(k, updatedBody))
          })

          dispatch(getNextStep(proof))
        }
      })
    })
    .catch(err => {
      if (err.type === 'tim-unauthorized') {
        const { routing } = getState()

        const mobileConnectUri = `${
          getEnv() === 'pro'
            ? 'https://mobileconnect.mp.tim.it'
            : 'https://autenticazione.collaudo.telecomitalia.it'
        }/OAUTHServer/OauthAuthorization`

        let redirectUri

        if (routing.locationBeforeTransitions.query.redirect_uri) {
          redirectUri = `${mobileConnectUri}${
            routing.locationBeforeTransitions.search
          }`
        } else {
          const appRoot = `${location.origin}${process.env.APP_ROOT}` //'https://www.pp-hype.it/signup'

          redirectUri = `${mobileConnectUri}?scope=${encodeURIComponent(
            'openid phone profile'
          )}&redirect_uri=${encodeURIComponent(
            appRoot +
              `/oauth-request/hype4tim/${
                !!initQuery.embedded ? 'embedded' : 'standalone'
              }`
          )}&response_type=code&client_id=HYPE&state=NOTREGISTERED&nonce=nonce_value&prompt=login&acr_values=${encodeURIComponent(
            'http://autenticazione.telecomitalia.it/SAM/assurance/Loa2&max_age=3600&login_hint='
          )}`
        }

        if (!!err.responseCode) {
          dispatch(
            handleServerErrors({
              status: 'error',
              message: err.type,
              redirectUri
            })
          )
        } else {
          location.href = redirectUri
        }
      }
    })
}

/**
 * Gets the user's contracts list
 * @public
 *
 * @param {string}      guid        The session guid
 * @return {Function}               Dispatches a SET_REQUEST_LIST action
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
export const getUserRequests = () => (dispatch, getState) => {
  const token = new ActionToken('step.getUserRequests')

  dispatch(dealActionToken(token))
  return API.getUserRequests().then(json => {
    dispatch(handleServerErrors(json))

    const { step } = getState()

    if (!step.hasServerErrors) {
      dispatch(updateAllWidgets({}))
      dispatch(updateAllComponents({}))
      dispatch({ type: SET_REQUEST_LIST, requestList: json.data })
    }
    dispatch(dealActionToken({ ...token, dispose: true }))
    return json
  })
}

/**
 * Opens the OTP sms prompt to recover an onboarding process
 * @public
 *
 * @param {string}      guid      The session guid
 * @return {Function}             Dispatches a REQUIRE_STEP_TO_RESUME_BY_VERIFICATION action
 */
export const requireResumeOtpSms = guid => (dispatch, getState) => {
  dispatch(validateStep())
  const { components } = getState()
  
  if (!Object.keys(components).find(k => isEntityInvalid(k, components))) {
    const token = new ActionToken('step.requireResumeOtpSms')

    dispatch(dealActionToken(token))
    // const { components } = getState()
    const body = {
      cf: components['CODICE_FISCALE-CF'].value,
      mail: components['EMAIL-EMAIL'].value,
      numCell: components['CELLULARE-NUM_CELLULARE'].value,
      prefCell: components['CELLULARE-PREF_CELLULARE'].value
    }

    API.requireResumeOtpSms(body, guid).then(json =>
      {
        if(!!json && json!==null)
        {
          dispatch(stepCallback(token, json))
        }
        else {
          //dispatch(hideLoading());
          dispatch(showAPIAlertModel())
          //return json
        }
      }
    )
  }
}

/**
 * Gets the user's contract list
 * @public
 *
 * @param {Array}      guids        The sessions guid
 * @return {Promise}                Dispatches a SET_CONTRACT_LIST action
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
export const getContracts = guids => (dispatch, getState) => {
  const token = new ActionToken('step.getContracts')

  dispatch(dealActionToken(token))

  const contractsCallback = guid => {
    return API.getContracts(guid).then(json => {
      dispatch(handleServerErrors(json))
      return json.data.map(c => {
        c.guid = guid
        return c
      })
    })
  }

  return Promise.all(guids.map(guid => contractsCallback(guid))).then(json => {
    const { step } = getState()
    if (!step.hasServerErrors) {
      dispatch({ type: SET_CONTRACT_LIST, contractList: [].concat(...json) })
    }
    dispatch(dealActionToken({ ...token, dispose: true }))
  })
}

/**
 * Gets the user's contract list
 * @public
 *
 * @param {string}      guid          The session guid
 * @param {string}      flow          The flow code (partnership-convention)
 * @return {Function}                 Dispatches a UPDATE_STEP action
 */
export const initRecoveryProcess = (guid, flow) => (
  dispatch /*, getState*/
) => {
  const token = new ActionToken('step.initRecoveryProcess')

  dispatch(dealActionToken(token))
  return API.initRecoveryProcess(guid).then(json => {
    if (json.step.name === 'list') {
      pushRoute(`/status${!!flow ? '/' + flow : ''}`)
      //@remarks don't dispatch the stepCallback here
      //otherwise the components reducer or the extendModel method will fail
      dispatch(dealActionToken({ ...token, dispose: true }))
    } else if (json.step.name === 'validate') {
      json.step.widgets
        .find(({ name }) => name === 'CELLULARE')
        .components.find(
          ({ name }) => name === 'CODICE_CELLULARE'
        ).active = false
      pushRoute(`/resume${!!flow ? '/' + flow : ''}`)
      dispatch(stepCallback(token, json))
    }
  })
}

/**
 * Resumes an onboarding process
 * @public
 *
 * @param {string}      guid          The session guid
 * @param {string}      flow          The flow code (partnership-convention)
 * @return {Promise}                  Dispatches a UPDATE_STEP action
 */
export const initResumeProcess = (guid, flow) => (dispatch, getState) => {
  const token = new ActionToken('step.initResumeProcess')

  dispatch(dealActionToken(token))

  if (!!guid) {
    if (!!getState().step && !!getState().step.isUnderage) {
      dispatch({ type: SET_IS_UNDERAGE, isUnderage: null })
    }

    return API.initResumeProcess(guid)
      .catch(ex => ({ status: 'error', message: ex }))
      .then(json => {
        if (json.status === 'redirect') {
          dispatch(initRecoveryProcess(guid, flow))
          dispatch(dealActionToken({ ...token, dispose: true }))
        } else {
          dispatch(stepCallback(token, json))
        }
      })
  } else {
    dispatch(initRecoveryProcess(guid, flow))
    dispatch(dealActionToken({ ...token, dispose: true }))
  }
}

/**
 * Recovers an onboarding session after a successful OTP validation
 * @public
 *
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
export const resumeProcess = () => (dispatch, getState) => {
  const token = new ActionToken('step.resumeProcess')

  let startJson

  dispatch(dealActionToken(token))
  API.resumeProcess()
    .then(json => {
      startJson = json
      return API.getProductInfo()
    })
    .then(jsonPc => {
      dispatch(handleServerErrors(jsonPc))
      const { step } = getState()
      if (!step.hasServerErrors) {
        dispatch(updateProduct(jsonPc.data))
      }
      return startJson
    })
    .then(json => dispatch(stepCallback(token, json)))
}

/**
 * Recovers an onboarding session from the dossier list
 * @public
 *
 * @param  {string}     guid              The session guid
 * @return {Function}                     Dispatches a UPDATE_STEP action
 */
export const resumeContactProcess = guid => (dispatch, getState) => {
  const token = new ActionToken('step.resumeContactProcess')

  dispatch(dealActionToken(token))

  let startJson

  API.resumeContactProcess(guid)
    .then(json => {
      startJson = json
      return API.getProductInfo()
    })
    .then(jsonPc => {
      dispatch(handleServerErrors(jsonPc))
      const { step } = getState()
      if (!step.hasServerErrors) {
        dispatch(updateProduct(jsonPc.data))
      }
      return startJson
    })
    .then(json => dispatch(stepCallback(token, json)))
}

/**
 * Resumes reupload of document in  onboarding process
 * @public
 *
 * @param  {string}      guid         The session guid
 * @param  {string}      barCode      The document barCode
 * @param  {string}      docType      The document type
 * @param  {Boolean}     showSelfie   Establishes if the selfie widget should be added to the mock
 * @return {Promise}                  Dispatches a UPDATE_STEP action
 */
export const initReuploadProcess = (guid, barCode, docType, showSelfie) => (
  dispatch /*, getState*/
) => {
  const token = new ActionToken('step.initReuploadProcess')

  dispatch(dealActionToken(token))
  const json = API.initReuploadProcess(guid, barCode, docType, showSelfie)
  dispatch(stepCallback(token, json))
}

/**
 * Complete contract to reupload and redirect to final step
 * @public
 * @param  {string}      guid         The session guid
 * @param  {string}      barCode1     The document barcode1
 * @param  {string}      barCode2     The document barcode2
 * @return {Function}                 Dispatches a UPDATE_STEP action
 */
export const completeReupload = (guid, barCode1, barCode2) => (
  dispatch,
  getState
) => {
  const token = new ActionToken('step.completeReupload')

  dispatch(dealActionToken(token))
  API.completeReupload(guid, barCode1, barCode2).then(json => {
    dispatch(handleServerErrors(json))

    const { step } = getState()
    if (!step.hasServerErrors) {
      dispatch(dealActionToken({ ...token, dispose: true }))
      pushRoute('/status')
    }
  })
}

/**
 * Validates a resume OTP
 * @public
 *
 * @param  {Object}   component     The component that contains the OTP
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
export const validateResumeOtp = (component,flow) => (dispatch, getState) => {
  dispatch(validateStep())

  const { components: componentsToCheck } = getState()

  if (
    !Object.keys(componentsToCheck).find(k =>
      isEntityInvalid(k, componentsToCheck)
    )
  ) {
    const token = new ActionToken('step.validateResumeOtp')

    dispatch(dealActionToken(token))

    const { components: initialComponents } = getState()

    API.validateResumeOtp(
      component.value,
      !initialComponents['RESUME_BY_CELL-GUID_PROCESSO'].value
    ).then(json => {
      dispatch(handleServerErrors(json))

      const { step, components } = getState()

      if (!step.hasServerErrors) {
        if (!!components['RESUME_BY_CELL-GUID_PROCESSO'].value) {
          dispatch(resumeProcess())
        } else {
          dispatch(
            initRecoveryProcess(
              components['RESUME_BY_CELL-GUID_PROCESSO'].value, flow
            )
          )
        }
      }
      dispatch(dealActionToken({ ...token, dispose: true }))
    })
  }
}
export const GetPOSPlan=(stepNumber,productcode,guid)=>
{
      let url = 'OnboardRequestDetails/FetchPOSPlan';
      let body = { GUID: guid };
      FetchPOSPlan(url, body).then(json => {
          json.payLoad.plan = !!json.payLoad && !!json.payLoad.Plan && json.payLoad.Plan.toUpperCase()==='FLEX' ? 'flex' : (!!json.payLoad && !!json.payLoad.Plan && json.payLoad.Plan.toUpperCase() === 'FLEXCRS'?'flexCRS':(!!json.payLoad && !!json.payLoad.Plan && json.payLoad.Plan.toUpperCase() === 'FLATCRS'?'flatCRS':'flat'));
      })
  
}
export const urlParam=(name)=>{
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results == null){
     return null;
  }
  else {
     return decodeURI(results[1]) || 0;
  }
}
/**
 * Gets the next step in the onboarding process
 * @public
 * @param {Object} proof           The encrypted third party data container
 * @return {Function}               Dispatches a NEXT_STEP action
 */
export const getNextStep = proof => (dispatch, getState) => {
  dispatch(validateStep())
  
  const token = new ActionToken('step.getNextStep')

  dispatch(dealActionToken(token))

  const checkPendingActions = () => {
    const { widgets, components, step, product } = getState()
    if(!!widgets["POSPLAN"])
    {
      delete widgets["POSPLAN"]
    }
    if(!!components['POSPLAN-PLAN'])
    {
        delete components['POSPLAN-PLAN']
    }
    //acolQuestionnaire widget issue - begin
    if (
      !!components['SEDE_LEGALE-NAZIONE'] &&
      !!components['SEDE_LEGALE-NAZIONE'].value
    ){
      components['SEDE_LEGALE-NAZIONE'].value = components['SEDE_LEGALE-NAZIONE'].value.toUpperCase()
    }
    //acolQuestionnaire widget issue - end
    if(!!components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'] && !!components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value &&
    components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value.indexOf('-')===-1 && components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value.indexOf('+')===-1)
    {
      components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value="+"+components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value
    }

    if (step.pendingActions.filter(a => !a.blocking).length > 0) {
      window.setTimeout(checkPendingActions, 100)
    } else {
      if (
        step.number === 5 &&
        product.partnership === posProducts.prodAzienda && !!widgets["TITOLARE_EFFETTIVO"] && 
        !!widgets["TITOLARE_EFFETTIVO"].status && 
        widgets["TITOLARE_EFFETTIVO"].status[0]==='ignoreValidation' &&
        !!components["TITOLARE_DATA-EFFETTIVO_SI"] && 
        components["TITOLARE_DATA-EFFETTIVO_SI"].value===''
      && !!components["TITOLARE_DATA-EFFETTIVO_NO"] && 
      components["TITOLARE_DATA-EFFETTIVO_NO"].value===''
      ) {
        const tocomponents = Model.Titolare_Effectivo_EmptyJSONResponse
        API.saveTitolare(tocomponents, step.number, widgets).then(json => {
          if (json.status === 'success') {
            if (!!proof) {
              json.proof = proof
            }
            //GetPOSPlan(step.number,product.partnership,step.guid)
            dispatch(stepCallback(token, json, widgets, components))
          }
        })
      }
      else {
      if (!Object.keys(components).find(k => isEntityInvalid(k, components))) {
        if (
          !!components['SIGNALER-PROMO_CODE'] &&
          !!components['SIGNALER-PROMO_CODE'].redirectRequired
        ) {
          dispatch(
            startProcess({
              partnership: product.partnership,
              convention: components['SIGNALER-PROMO_CODE'].value.toUpperCase(),
              proof,
              reboot: true
            })
          ).then(() => {
            dispatch(dealActionToken({ ...token, dispose: true }))
          })
        } else {
          //save Pg call
          if (
            (Model.savePG &&
              step.number === 4 &&
              !!components['AZIENDA_ANTIRICICLAGGIO-QUESTIONARIO']) ||
            (Model.savePG &&
              step.number === 3 &&
              !!components['ANTIRICICLAGGIO-QUESTIONARIO'])
          ) {   
      
            //acolQuestionnaire widget issue - begin
            if(Model.savePG && !!Model.savePG.data && !!Model.savePG.data.acolQuestionnaire){
              buildSavePg(Model.savePG, components)
            }     
            //acolQuestionnaire widget issue - end
            API.savePg(Model.savePG, step.number).then(jsonPg => {
              if (jsonPg.status === 'success') {
                API.getNextStep(widgets, components, step.number).then(json => {
                  if (!!proof) {
                    json.proof = proof
                  }
                  //(step.number,product.partnership,step.guid)
                  dispatch(stepCallback(token, json, widgets, components))
                })
              } else {
                dispatch(dealActionToken({ ...token, dispose: true }))
                dispatch(handleServerErrors(jsonPg))
              }
            })
          } else if (
            step.number === 5 &&
            product.partnership === posProducts.prodAzienda
          ) {
            const tocomponents = buildTitolareRequest(step.titolareList)
            API.saveTitolare(tocomponents, step.number, widgets).then(json => {
              if (json.status === 'success') {
                if (!!proof) {
                  json.proof = proof
                }
                //GetPOSPlan(step.number,product.partnership,step.guid)
                dispatch(stepCallback(token, json, widgets, components))
              }
            })
          } else if (
            (step.number === 6 &&
              product.partnership === posProducts.prodAzienda) ||
            (step.number === 4 &&
              product.partnership === posProducts.prodPersonaFisica) ||
            (step.number === 5 &&
              product.partnership === posProducts.prodDittaInd)
          ) {
            const toWidgets = buildPersonalizzaPOSRequest(
              widgets,
              components,
              step
            )
            API.savePersonalizzaPOS(toWidgets, step.number).then(json => {
              if (json.status === 'success') {
                if (!!proof) {
                  json.proof = proof
                }
                //GetPOSPlan(step.number,product.partnership,step.guid)
                dispatch(stepCallback(token, json, widgets, components))
              }
            })
          } 
          else {
            const promoCodeComp = {}
            if (step.number === 1) {
              const queryParam=urlParam('plan');
              const queryrefParam=urlParam('ref');
              promoCodeComp.ContactId = !!step.contactId? step.contactId:''
              promoCodeComp.Guid = step.guid
              promoCodeComp.CodiceFiscale = components["CODICE_FISCALE-CF"].value
              promoCodeComp.MerchantName = ''
              promoCodeComp.VatNumber = !!components["PARTITA_IVA-NUM_PARTITA_IVA"] && components["PARTITA_IVA-NUM_PARTITA_IVA"].value ? components["PARTITA_IVA-NUM_PARTITA_IVA"].value : ""
              promoCodeComp.PromoCode = queryrefParam//!!components["PROMO-PromoCode"] && components["PROMO-PromoCode"].value ? components["PROMO-PromoCode"].value : ""
              promoCodeComp.SalesManID=!!components["PROMO-PromoCode"] && components["PROMO-PromoCode"].salesManId ? components["PROMO-PromoCode"].salesManId : ""
              promoCodeComp.CreationDate = ''
              promoCodeComp.ModifiedDate = ''
              promoCodeComp.Nome=!!components["NOME_COGNOME-NOME"] && components["NOME_COGNOME-NOME"].value ? components["NOME_COGNOME-NOME"].value : ""
              promoCodeComp.Email = !!components["EMAIL-EMAIL"]&& components["EMAIL-EMAIL"].value ? components["EMAIL-EMAIL"].value:""
              promoCodeComp.PLAN=(queryParam && queryParam.toUpperCase()==='FLEX'?'flex':(queryParam && queryParam.toUpperCase()==='FLEXCRS'?'flexCRS':(queryParam && queryParam.toUpperCase()==='FLATCRS'?'flatCRS':'flat')))
              if (product.prodCode === 'POS_AZIENDA_EASYNOLO' ||
                product.prodCode === 'POS_DITTA_IND_EASYNOLO') {
                promoCodeComp.RagioneSociale = !!components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"]
                  && components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"].value
                  ? components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"].value : ""
              }
            }

            setTimeout(() => {
              API.getNextStep(widgets, components, step.number).then(json => {
                if (!!proof) {
                  json.proof = proof
                }

                if (!!json.step && json.step.number === 2) {
                  promoCodeComp.ContactId = !!json.step.contactId ? json.step.contactId : ''
                  API.insertPromoCode(promoCodeComp).then(json => {
                    console.log("Inserted details in step 1", json)
                  })
                }
                dispatch(stepCallback(token, json, widgets, components))
              })
            }, 1000)
          }
          if ((product.prodCode === 'POS_AZIENDA_EASYNOLO' && ( /*step.number === 1 ||*/ step.number === 3 || step.number === 6 || step.number === 2)) ||
            (product.prodCode === 'POS_DITTA_IND_EASYNOLO' && ( /*step.number === 1 ||*/ step.number === 3 || step.number === 5 || step.number === 4)) ||
            (product.prodCode === 'POS_PERSONA_FISICA_EASYNOLO' && (step.number === 2 || step.number === 3 || step.number === 4))) {
            let body = null

            if ((product.prodCode === 'POS_AZIENDA_EASYNOLO' && step.number === 3) ||
              (product.prodCode === 'POS_DITTA_IND_EASYNOLO' && step.number === 3)) {
                let provincia = components["SEDE_LEGALE-PROVINCIA"].values.find(el => el.value === components["SEDE_LEGALE-PROVINCIA"].value);
              body = {
                Guid: step.guid,
                INDIRIZZO: !!components["SEDE_LEGALE-INDIRIZZO"] && components["SEDE_LEGALE-INDIRIZZO"].value ? components["SEDE_LEGALE-INDIRIZZO"].value : "",
                CITTA: !!components["SEDE_LEGALE-CITTA"] && components["SEDE_LEGALE-CITTA"].value ? components["SEDE_LEGALE-CITTA"].value : "",
                //PROVINCIA: !!components["SEDE_LEGALE-PROVINCIA"] && components["SEDE_LEGALE-PROVINCIA"].value ? components["SEDE_LEGALE-PROVINCIA"].value : ""
                PROVINCIA: !!components["SEDE_LEGALE-PROVINCIA"] && components["SEDE_LEGALE-PROVINCIA"].value ? components["SEDE_LEGALE-PROVINCIA"].value+"-"+provincia["description"] : ""
              }
            }
            else if (product.prodCode === 'POS_PERSONA_FISICA_EASYNOLO' && step.number === 2) {
              let provincia = components["RESIDENZA-PROVINCIA"].values.find(el => el.value === components["RESIDENZA-PROVINCIA"].value);
              body = {
                Guid: step.guid,
                INDIRIZZO: !!components["RESIDENZA-INDIRIZZO"] && components["RESIDENZA-INDIRIZZO"].value ? components["RESIDENZA-INDIRIZZO"].value : "",
                CITTA: !!components["RESIDENZA-CITTA"] && components["RESIDENZA-CITTA"].value ? components["RESIDENZA-CITTA"].value : "",
                //PROVINCIA: !!components["RESIDENZA-PROVINCIA"] && components["RESIDENZA-PROVINCIA"].value ? components["RESIDENZA-PROVINCIA"].value : ""
                PROVINCIA: !!components["RESIDENZA-PROVINCIA"] && components["RESIDENZA-PROVINCIA"].value ? components["RESIDENZA-PROVINCIA"].value+"-"+provincia["description"] : ""
              }
            }
            else if ((product.prodCode === 'POS_AZIENDA_EASYNOLO' && step.number === 6) ||
              (product.prodCode === 'POS_DITTA_IND_EASYNOLO' && step.number === 5) ||
              (product.prodCode === 'POS_PERSONA_FISICA_EASYNOLO' && step.number === 4)) {
              body = {
                Guid: step.guid,
                INSEGNA: !!components["S1-S1S1D1"] && components["S1-S1S1D1"].value ? components["S1-S1S1D1"].value : "",
                DATAPROCESSINGVISIONE: !!components["S11-S11S0D11"] && components["S11-S11S0D11"].value==="selected" ? "1" : "0",
                PRESERVEDOCUMENTATIONVISIONE: !!components["S11-S11S1D11"] && components["S11-S11S1D11"].value==="selected" ? "1" : "0",
                DETECTIONVISIONE: !!components["S11-S11S2D11"] && components["S11-S11S2D11"].value==="selected" ? "1" : "0",
                DATACOMMUNICATIONVISIONE: !!components["S11-S11S3D11"] && components["S11-S11S3D11"].value==="selected" ? "1" : "0",
                PROFILINGVISIONE: !!components["S11-S11S4D11"] && components["S11-S11S4D11"].value==="selected" ? "1" : "0"
              }
              if (!!components["S1-S1S0D10"] && components["S1-S1S0D10"].value === 'selected') {
                body.INDIRIZZO = !!components["S1-INDIRIZZO"] && components["S1-INDIRIZZO"].value ? components["S1-INDIRIZZO"].value : ""
                body.CITTA = !!components["S1-CITTA"] && components["S1-CITTA"].value ? components["S1-CITTA"].value : ""
                body.PROVINCIA = !!components["S1-PROVINCIA"] && components["S1-PROVINCIA"].value ? components["S1-PROVINCIA"].value : ""
              }
            }
            // else if ((product.prodCode === 'POS_AZIENDA_EASYNOLO' && step.number === 1) ||
            //   (product.prodCode === 'POS_DITTA_IND_EASYNOLO' && step.number === 1)) {
            //   body = {
            //     Guid: step.guid,
            //     RAGIONESOCIALE: !!components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"] && components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"].value ? components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"].value : ""
            //   }
            // }
            else if (product.prodCode === 'POS_PERSONA_FISICA_EASYNOLO' && step.number === 3) {
              body = {
                Guid: step.guid,
                RAGIONESOCIALE: !!components["SZ0009-SS0010_DM0024_RI0019"] && components["SZ0009-SS0010_DM0024_RI0019"].value ? components["SZ0009-SS0010_DM0024_RI0019"].value : "",
                DATISENSIBILIVISIONE: !!components["DATI_SENSIBILI-VISIONE"] && components["DATI_SENSIBILI-VISIONE"].value==="selected" ? "1" : "0",
                CRONISTORIAVISIONE: !!components["CRONISTORIA-VISIONE"] && components["CRONISTORIA-VISIONE"].value==="selected" ? "1" : "0",
                PROMOZIONEVISIONE: !!components["PROMOZIONE-VISIONE"] && components["PROMOZIONE-VISIONE"].value==="selected" ? "1" : "0",
                PROMOZIONETERZIVISIONE: !!components["PROMOZIONE_TERZI-VISIONE"] && components["PROMOZIONE_TERZI-VISIONE"].value==="selected" ? "1" : "0",
                PROFILAZIONEVISIONE: !!components["PROFILAZIONE-VISIONE"] && components["PROFILAZIONE-VISIONE"].value==="selected" ? "1" : "0"
              }
            }
            else if (product.prodCode === 'POS_AZIENDA_EASYNOLO' && step.number === 2) {
              body = {
                Guid: step.guid,
                DATISENSIBILIVISIONE: !!components["DATI_SENSIBILI-VISIONE"] && components["DATI_SENSIBILI-VISIONE"].value==="selected" ? "1" : "0",
                CRONISTORIAVISIONE: !!components["CRONISTORIA-VISIONE"] && components["CRONISTORIA-VISIONE"].value==="selected" ? "1" : "0",
                PROMOZIONEVISIONE: !!components["PROMOZIONE-VISIONE"] && components["PROMOZIONE-VISIONE"].value==="selected" ? "1" : "0",
                PROMOZIONETERZIVISIONE: !!components["PROMOZIONE_TERZI-VISIONE"] && components["PROMOZIONE_TERZI-VISIONE"].value==="selected" ? "1" : "0",
                PROFILAZIONEVISIONE: !!components["PROFILAZIONE-VISIONE"] && components["PROFILAZIONE-VISIONE"].value==="selected" ? "1" : "0"
              }
            }
            else if (product.prodCode === 'POS_DITTA_IND_EASYNOLO' && step.number === 4) {
              body = {
                Guid: step.guid,
                DATISENSIBILIVISIONE: !!components["DATI_SENSIBILI-VISIONE"] && components["DATI_SENSIBILI-VISIONE"].value==="selected" ? "1" : "0",
                CRONISTORIAVISIONE: !!components["CRONISTORIA-VISIONE"] && components["CRONISTORIA-VISIONE"].value==="selected" ? "1" : "0",
                PROMOZIONEVISIONE: !!components["PROMOZIONE-VISIONE"] && components["PROMOZIONE-VISIONE"].value==="selected" ? "1" : "0",
                PROMOZIONETERZIVISIONE: !!components["PROMOZIONE_TERZI-VISIONE"] && components["PROMOZIONE_TERZI-VISIONE"].value==="selected" ? "1" : "0",
                PROFILAZIONEVISIONE: !!components["PROFILAZIONE-VISIONE"] && components["PROFILAZIONE-VISIONE"].value==="selected" ? "1" : "0"
              }
            }

            API.updateOnboardingDetails(body);
          }

        }
      } else {
        const invalidAddressComponentKey = Object.keys(components).find(
          k =>
            components[k].status.indexOf('error') > -1 &&
            components[k].name === 'INDIRIZZO' &&
            components[k].values.length > 0
        )

        if (!!invalidAddressComponentKey) {
          dispatch(showAddressModal(components[invalidAddressComponentKey]))
        }

        scrollToFirstInvalidComponent(components)
        dispatch(dealActionToken({ ...token, dispose: true }))
      }
    }
    }
  }

  checkPendingActions()
}

/**
 * Gets the previous step in the onboarding process
 * @public
 * @param  {Object} proof proof
 *
 * @return {Function}  dispatches a PREV_STEP action
 */
export const getPrevStep = proof => (dispatch, getState) => {
  const token = new ActionToken('step.getPrevStep')

  dispatch(dealActionToken(token))
  const { widgets, components } = getState()
  dispatch({ type: USER_COUNTER , userCounter: 0})
    dispatch({
        type: SET_TITOLARE_LIST,
        titolareList: []
    })
  return API.getPrevStep().then(json =>
    dispatch(stepCallback(token, { ...json, proof }, widgets, components))
  )
}

/**
 * Hides a modal if there are server errors
 * @public
 *
 * @return {Function}   Dispatches an HANDLE_SERVER_ERRORS action
 */
export const hideModal = () => ({
  type: HANDLE_SERVER_ERRORS,
  hasServerErrors: false,
  serverErrorMessage: ''
})

export const thanks = parentGuid => (dispatch, getState) => {
  const { step } = getState()
  const token = new ActionToken('step.thanks')

  if (!!step.contactId) {
    getStoredState().updateSession(step.contactId,step.guid, step.number, !!step.isParent)
  }

  const thanksJSON = API.initThankYouPage(step.contactId, parentGuid)
  thanksJSON.step.guid=step.guid
  thanksJSON.step.number = step.number + 1
  thanksJSON.step.last = false
  dispatch(stepCallback(token, thanksJSON))
}

export const acknowledgeContract = () => (dispatch, getState) => {
  const { step, components, widgets } = getState()
  const token = new ActionToken('step.acknowledgeContract')

  // Coupon start
  let posPlanInQueryString=urlParam('plan')
  const promoCodeComp = {}
  promoCodeComp.PromoCode = components["PROMO-PromoCode"] && components["PROMO-PromoCode"].value ? components["PROMO-PromoCode"].value : ""
  promoCodeComp.Guid = step.guid
  if(promoCodeComp.PromoCode) {
    const userReqBody={}
    const sendMailPromoCode ={}
    let promoCodeValue = components["PROMO-PromoCode"].value
    API.FetchPOSOnboardDetails('OnboardRequestDetails/FetchPOSOnboardingDetails', { GUID:step.guid }).then(json => {
      if(json && json.payLoad) {
        //CheckUserExists API data
          userReqBody.PromoCode= components["PROMO-PromoCode"].value,
          userReqBody.CodiceFiscale= json.payLoad.CodiceFisicale,
          userReqBody.VatNumber= json.payLoad.Vatnumber
        //SendMail API Data
        sendMailPromoCode.Guid=step.guid,
        sendMailPromoCode.ContactId=step.contactId,
        sendMailPromoCode.FirstName=json.payLoad.FirstName,
        sendMailPromoCode.Email=json.payLoad.Email,
        //sendMailPromoCode.PromoCode=promoCodeComp.PromoCode,
        sendMailPromoCode.Plan=posPlanInQueryString
      }
    API.ValidatePromoCode('PromoCodeManagement/ValidatePromoCode', { promocode: promoCodeValue , plan: posPlanInQueryString, PivaORCodicefisicale:!!userReqBody ? userReqBody.CodiceFiscale:'' }).then(res => {
      let couponValidation = (res.error && res.error.description) ? [res.error.description] : ""
      if (couponValidation) {
        const component = components["PROMO-PromoCode"]               
        const updateBody={}
        updateBody.status = union(components["PROMO-PromoCode"].status, ['error'])
        updateBody.errorMessage = couponValidation

        dispatch({
          type:  UPDATE_COMPONENT,
          component: { ...updateBody, id: component.id }
        })
        dispatch(dealActionToken({ ...token, dispose: true }))
      } else {
            promoCodeComp.SalesManID=res.payLoad.SalesManId
            API.ValidateUser('OnboardRequestDetails/CheckUserExists', userReqBody).then(response => {
              let userValidation = (!!response.error && !!response.error.description) ? [response.error.description] : ""
              if (userValidation) {
                const component = components["PROMO-PromoCode"]               
                const updateBody={}
                //updateBody.status = union(components["PROMO-PromoCode"].status, ['error'])
                updateBody.errorMessage = userValidation
      
                dispatch({
                  type:  UPDATE_COMPONENT,
                  component: { ...updateBody, id: component.id }
                })
                dispatch(dealActionToken({ ...token, dispose: true }))
              }
              else {
                promoCodeComp.promoCode=res.payLoad.PromoCode
                API.updateOnboardingDetails(promoCodeComp).then(json => {
                  sendMailPromoCode.IsReferalCode=res.payLoad.IsReferalCode
                  sendMailPromoCode.PromoCode=res.payLoad.PromoCode
                  API.SendMailWithPromoCode(sendMailPromoCode).then(json=>{
                    console.log("Mail sent successfully")
                  })
                  acknowledgeContractFinal(dispatch, getState);
                  
                })
              }
            });
          }
        });
    });
    // Coupon end
  } else {
    API.FetchPOSOnboardDetails('OnboardRequestDetails/FetchPOSOnboardingDetails', { GUID:step.guid }).then(json => {
      if(json && json.payLoad) {
        const sendMailPromoCode = {
          Guid:step.guid,
          ContactId:step.contactId,
          FirstName:json.payLoad.FirstName,
          Email:json.payLoad.Email,
          PromoCode:promoCodeComp.PromoCode,
          Plan:posPlanInQueryString,
          IsReferalCode:false
        };
        const ReferalCodeComp = {
              PromoCode : "",
              Guid : step.guid
        }
        API.UpdateReferalCode(ReferalCodeComp).then(json => {
        API.SendMailWithPromoCode(sendMailPromoCode).then(json=>{
          console.log("Mail sent successfully")
           })
         })
        acknowledgeContractFinal(dispatch, getState);
        
      }
    })
  }
}

const getCurrentDate = () => {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; 
  var yyyy = today.getFullYear();
  if(dd < 10) dd = '0' + dd;
  if(mm < 10) mm = '0' + mm;
  return dd + '/' + mm + '/' + yyyy;
}

const acknowledgeContractFinal = (dispatch, getState) => {
  const { step, components, widgets } = getState()
  const token = new ActionToken('step.acknowledgeContract')

  dispatch(dealActionToken(token))
  API.acknowledgePOSContract({ step, components, widgets }).then(stepJson => {
    dispatch(handleServerErrors(stepJson))

    const { step: newStep } = getState()

    if (!newStep.hasServerErrors) {
      if (!!step.auth && !!step.auth.tokenId) {
        dispatch(logout())
      }
        
        let date = new Date
        let body = {
          Guid: step.guid,
          // OnBoardCompletionDt: (date.getUTCDate() + '/' + date.getUTCMonth()+1 + '/' + date.getUTCFullYear())
          OnBoardCompletionDt: getCurrentDate()
        }
        API.updateOnboardingDetails(body);       

      dispatch(
        thanks(
          !!components['TERMINA_PROCEDURA-RESUME_INTEST_2'] &&
            components['TERMINA_PROCEDURA-RESUME_INTEST_2'].value
        )
      )
    }
    dispatch(dealActionToken({ ...token, dispose: true }))
  })
}

/**
 * Create a Pg save request and dispatch the request
 * @public
 * @param  {Object} savePG        The savePG
 * @param  {Object} components     The component
 */
export const buildSavePg = (savePG, components) => {
  //const section = savePG.data.acolQuestionnaire.sections.section
  const currEnabled = {
    subSections: [],
    questions: [],
    answers: []
  }
  Object.keys(components).forEach(key => {
    const currentComponents = components[key]
    if (
      currentComponents.isSubSection &&
      currentComponents.refId &&
      currentComponents.id_
    ) {
      currEnabled.subSections.push(currentComponents.id_)
    } else if (
      currentComponents.isQuestion &&
      currentComponents.refId &&
      currentComponents.id_
    ) {
      currEnabled.questions.push(currentComponents.id_)
    } else if (currentComponents.isAnswer && currentComponents.id_) {
      currEnabled.answers.push(currentComponents.id_)
      // if (
      //   currentComponents.linkId !== null &&
      //   currentComponents.field !== undefined &&
      //   currentComponents.field.linkValue !== null
      // ) {
      //   updateSavePg(savePG, currentComponents)
      // }
      updateSavePg(savePG, currentComponents)
    }
  })
  savePG.data.acolQuestionnaire.currentEnabled = currEnabled
  Model.savePG = savePG
}

const PersonalizzaPOSRequestType = {
  TEXTBOX: 'text',
  TEXTAREA: 'text',
  RADIO: 'radio',
  COMBO: 'combo',
  selectbox: 'combo',
  PHONE: 'phone',
  CHECKBOX: 'checkbox',
  NUMBER: 'text',
  ADDRESS: 'address',
  UPLOAD: 'upload'
}

export const buildPersonalizzaPOSRequest = (widgets, components, step) => {
  const toWidgets = []
  const widget = {}
  let PRODUCT_PLUGIN = null
  try {
    PRODUCT_PLUGIN = step.config.widget.PRODUCT_PLUGIN
    widget.code = PRODUCT_PLUGIN.code
  } catch (e) {
    widget.code = ''
  }
  widget.components = []
  const component = {}
  component.name = 'PLUGIN_USER_INPUT'
  component.rawValue = {}
  component.rawValue.section = []

  if (PRODUCT_PLUGIN && PRODUCT_PLUGIN.components) {
    const PLUGIN_TEMPLATE = PRODUCT_PLUGIN.components.find(
      c => c.name === 'PLUGIN_TEMPLATE'
    )
    const cList_ = Object.values(components).filter(
      c =>
        c.active === true &&
        c.type !== 'spacer' &&
        (c.type !== 'radio' ||
          (c.type === 'radio' && c.value === 'selected')) &&
        (c.type !== 'checkbox' ||
          (c.type === 'checkbox' && c.value === 'selected'))
    )
    const sections = PLUGIN_TEMPLATE.rawValue.sections
    let fields = []
    let field = null
    if (sections) {
      sections.forEach(s => {
        let section = null
        fields = []
        s.fields.forEach(f => {
          const cList = Object.values(cList_).filter(
            c =>
              c.name.startsWith(f.id) || (c.addressId && c.addressId === f.id)
          )
          field = null
          if (cList && cList.length) {
            cList.forEach(c => {
              /*    field =
                   field ||
                   (fields.length
                     ? fields.find(
                         f_ =>
                           f_.fieldId === c.fieldId ||
                           (c.addressId && c.addressId === f_.fieldId)
                       )
                     : null) */
              field = field || {
                fieldId: f.id,
                fieldDescription: (!c.addressId && c.cleanName) || '',
                fieldType:
                  PersonalizzaPOSRequestType[f.type] ||
                  PersonalizzaPOSRequestType[c.type] ||
                  c.type
              }
              if (
                (f.type === 'ADDRESS' && c.addressId && c.addressId === f.id) ||
                ((f.type === 'PHONE' || f.type === 'UPLOAD') &&
                  c.fieldId &&
                  c.fieldId === f.id)
              ) {
                field.fieldValue = field.fieldValue || []
                if (f.type === 'UPLOAD') {
                  field.fieldValue.push({
                    description: 'FILE_NAME',
                    value: c.fileName
                  })
                  field.fieldValue.push({
                    description: 'DOC_REF_ID',
                    value: s.id + '##' + f.id
                  })
                } else {
                  field.fieldValue.push({
                    description: f.type === 'PHONE' ? c.description : c.name,
                    value: c.value
                  })
                }
              } else {
                field.fieldValue = /* field.fieldValue || */ []
                field.fieldValue.push({
                  description:
                    (c.type === 'text' && c.cleanName) ||
                    c._description ||
                    c.description ||
                    c.cleanName,
                  value:
                    c.type === 'radio' || c.type === 'checkbox'
                      ? c._code
                      : c.value
                })
                if (f.type === 'COMBO' && c.values && c.values.length) {
                  const valueObj = c.values.find(
                    v => v.value === field.fieldValue[0].value
                  )
                  if (valueObj && valueObj.label) {
                    field.fieldValue[0].description = valueObj.label
                  }
                }
              }
            })
          }
          if (field) {
            if (fields.length) {
              fields = fields.map(field_ => {
                return field_.fieldId === field.fieldId ? field : field_
              })
            }
            if (fields.indexOf(field) === -1) {
              fields.push(JSON.parse(JSON.stringify(field)))
            }
          }
        })
        if (fields.length) {
          section = {
            hidden: false,
            sectionId: s.id,
            sectionTitle: s.title || '',
            field: JSON.parse(JSON.stringify(fields))
          }
          component.rawValue.section.push(section)
        }
      })
    }
  }

  widget.components.push(component)

  toWidgets.push(widget)
  return toWidgets
}

export const buildTitolareRequest = titolareList => {
  let resComponents = []
  if (!!titolareList && titolareList.length >= 1) {
    let dpdKey = null
    const toComponents = [
      {
        name: 'TITOLARE_EFFETTIVO_DATA',
        rawValue: {
          titolare_effettivo: []
        }
      }
    ]

    const TYPES = {
      cf: 'codiceFiscale',
      nome: 'nome',
      cognome: 'cognome',
      datadinascita: 'dataDiNascita',
      sesso: 'sesso',
      luogodinascita: 'luogoDiNascita',
      provinciadinascita: 'provinciaDiNascita',
      meseAnno: 'meseAnno'
    }
    titolareList.map(user => {
      const tempUser = {
        id: '',
        legale_repre: '',
        directPep: '',
        indirectPep: '',
        criterioApplicato:'',
        datiContatto: {},
        residenza: {},
        documento: {
          doc_type: 'TEDOC',
          doc_ref_id: '',
          docr_upload: '',
          docf_upload: ''
        },
        directPepDetail: {},
        indirectPepDetail: {}
      }

      tempUser.id = user.id + 1
      if (user.userComponents['TITOLARE_DATA-EFFETTIVO_SI']) {
        tempUser.legale_repre =
          user.userComponents['TITOLARE_DATA-EFFETTIVO_SI'].value === 'selected'
            ? 'SI'
            : 'NO'
      }

      tempUser.directPep =
        user.userComponents['SZ0025-SS0052_DM0097_RI0022'].value === 'selected'
          ? 'SI'
          : 'NO'

      tempUser.indirectPep =
        user.userComponents['SZ0025-SS0163_DM0503_RI0568'].value === 'selected'
          ? 'SI'
          : 'NO'
          if(!!user.userComponents['SZ0025-SS0211_DM0854_RI0954'] && user.userComponents['SZ0025-SS0211_DM0854_RI0954'].value === 'selected')
          {
            tempUser.criterioApplicato= user.userComponents['SZ0025-SS0211_DM0854_RI0954'].description;
          }
          else if(!!user.userComponents['SZ0025-SS0211_DM0854_RI0955'] && user.userComponents['SZ0025-SS0211_DM0854_RI0955'].value === 'selected')
          {
            tempUser.criterioApplicato= user.userComponents['SZ0025-SS0211_DM0854_RI0955'].description;
          }
          else if(!!user.userComponents['SZ0025-SS0211_DM0854_RI0956'] && user.userComponents['SZ0025-SS0211_DM0854_RI0956'].value === 'selected')
          {
            tempUser.criterioApplicato= user.userComponents['SZ0025-SS0211_DM0854_RI0956'].description;
          }
      Object.keys(user.userComponents).forEach(key => {
        const currentComponents = user.userComponents[key]
        if (
          currentComponents.refDataTeJsObj &&
          currentComponents.refDataTeJsObj === 'directPepDetail'
        ) {
          dpdKey = currentComponents.refDataTeJs
          tempUser.directPepDetail[dpdKey] =
            currentComponents.value === 'selected'
              ? 'SI'
              : currentComponents.value
        }
        if (
          currentComponents.refDataTeJsObj &&
          currentComponents.refDataTeJsObj === 'indirectPepDetail'
        ) {
          dpdKey =
            currentComponents.refDataTeJs === 'tipolegame'
              ? 'tipoLegame'
              : currentComponents.refDataTeJs
          tempUser.indirectPepDetail[dpdKey] =
            currentComponents.value === 'selected'
              ? 'SI'
              : currentComponents.value
        }
        if (
          currentComponents.id.startsWith('RESIDENZA-') &&
          currentComponents.name !== 'INDIRIZZO_TIPO'
        ) {
          dpdKey = currentComponents.name.toLowerCase()
          tempUser.residenza[dpdKey] = currentComponents.value
            ? currentComponents.value
            : ''
        }
        if (
          currentComponents.id.startsWith('DOCUMENTO-') &&
          currentComponents.name !== 'DOCR_UPLOAD' &&
          currentComponents.name !== 'DOCF_UPLOAD'
        ) {
          dpdKey = currentComponents.name
          tempUser.documento[dpdKey.toLowerCase()] = currentComponents.value
            ? currentComponents.value
            : ''
        }
        if (
          currentComponents.name === 'DOCR_UPLOAD' ||
          currentComponents.name === 'DOCF_UPLOAD'
        ) {
          tempUser.documento.doc_ref_id = currentComponents.docRefId
        }
        if (
          currentComponents.id.startsWith('NOME_COGNOME-') ||
          currentComponents.id.startsWith('CODICE_FISCALE-')
        ) {
          dpdKey = currentComponents.name.toLowerCase()
          const rezKey = TYPES[dpdKey]
          tempUser.datiContatto[rezKey] = currentComponents.value
            ? currentComponents.value
            : ''
        }
      })
      toComponents[0].rawValue.titolare_effettivo.push(tempUser)
    })
    resComponents = toComponents
  }

  return resComponents
}

const updateSavePg = (savePG, c) => {
  const comId = c.id_
  for (const s of savePG.data.acolQuestionnaire.sections.section) {
    if (comId.startsWith(s.sectionCode) && s.subSections) {
      for (const ss_ of s.subSections.subSection) {
        if (comId.startsWith(ss_.id) && ss_.questions) {
          for (const q of ss_.questions.question) {
            if (comId.startsWith(q.id) && q.answers) {
              for (const a of q.answers.answer) {
                if (comId === a.id) {
                  if (a.field.type === 'Radio' || a.field.type === 'CheckBox') {
                    a.field.selected = c.value === 'selected'
                  } else if (
                    a.field.type === 'DropdownBox' ||
                    a.field.type === 'ListBox'
                  ) {
                    a.field.value = c.value
                    a.linkId = c.linkId
                    a.field.linkValue = c.linkValue
                  } else if (
                    a.field.type === 'TextBox' ||
                    a.field.type.toUpperCase() === 'DATEPICKER' ||
                    a.field.type.toUpperCase() === 'TEXTAREA'
                  ) {
                    a.field.value = c.value
                  }
                  return
                }
              }
            }
          }
        }
      }
    }
  }
}

//Update the User to State
export const addTitolareUserToObject = (userDetails, count) => (dispatch, getState) => {
  const { components, step } = getState()
  const titolareList = step.titolareList || []
  if (titolareList.length < 5) {
    userDetails.open = false
    Object.keys(userDetails.userComponents).forEach(k => {
      userDetails.userComponents[k].validations = !!components[k].validations && components[k].validations
    })
    if(
    !!userDetails.userWidgets["TITOLARE_EFFETTIVO"] && 
    !!userDetails.userWidgets["TITOLARE_EFFETTIVO"].status && 
    userDetails.userWidgets["TITOLARE_EFFETTIVO"].status[0]==='ignoreValidation' &&
    !!userDetails.userComponents && !!userDetails.userComponents['SZ0025-SS0052_DM0097_RI0022'] && 
    !!userDetails.userComponents['SZ0025-SS0052_DM0097_RI0023'] &&
    !!userDetails.userComponents['SZ0025-SS0163_DM0503_RI0568'] &&
    !!userDetails.userComponents['SZ0025-SS0163_DM0503_RI0569'] &&
    !!userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_SI'] &&
    !!userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_NO'] &&
    !!userDetails.userComponents['TITOLARE_OWNER-LABEL']  && 
    !!userDetails.userComponents['SZ0025-SS0163'] &&
    !!userDetails.userComponents['SZ0025-SS0052'])
    {
      userDetails.userComponents['SZ0025-SS0052_DM0097_RI0022'].status[0]='';
      userDetails.userComponents['SZ0025-SS0052_DM0097_RI0023'].status[0]='';
      userDetails.userComponents['SZ0025-SS0163_DM0503_RI0568'].status[0]='';
      userDetails.userComponents['SZ0025-SS0163_DM0503_RI0569'].status[0]='';
      userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_NO'].status[0]='';
      userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_NO'].value='selected';
      userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_SI'].status[0]=''; 
      userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_SI'].value='';
      userDetails.userComponents['TITOLARE_OWNER-LABEL'].status[0]=''; 
      userDetails.userComponents['SZ0025-SS0163'].status[0]=''; 
      userDetails.userComponents['SZ0025-SS0052'].status[0]=''; 
    }
    titolareList.push(userDetails)
    dispatch({ type: USER_COUNTER , userCounter: count})
    dispatch({
      type: SET_TITOLARE_LIST,
      titolareList: titolareList
    })
  }
}

export const getPrevTitolareUser = (user, titoValue) => (dispatch, getState) => {
  const { step } = getState()
  let dpdKey = null
  const TYPES = {
    cf: 'codiceFiscale',
    nome: 'nome',
    cognome: 'cognome',
    datadinascita: 'dataDiNascita',
    sesso: 'sesso',
    luogodinascita: 'luogoDiNascita',
    provinciadinascita: 'provinciaDiNascita',
    meseAnno: 'meseAnno'
  }
  const titolareList = step.titolareList

  //titolareList.map(user => {
    //const titoValue = userArray[user.id]

    Object.keys(user.userComponents).forEach(k => {
      const comp = user.userComponents[k]
      if (comp.id.startsWith('RESIDENZA-')) {
        dpdKey =
          comp.name === 'residenzaFiscale'
            ? 'residenzafiscale'
            : comp.name.toLowerCase()
            comp.value = !!titoValue.residenza && !!titoValue.residenza[dpdKey] ? titoValue.residenza[dpdKey] : ''  
      }
      if (
        comp.id.startsWith('DOCUMENTO-') &&
        comp.name !== 'DOCR_UPLOAD' &&
        comp.name !== 'DOCF_UPLOAD'
      ) {
        comp.value = !!titoValue.documento && !!titoValue.documento[comp.name.toLowerCase()] ? titoValue.documento[comp.name.toLowerCase()] : '' 
      }

      if (
        comp.id.startsWith('NOME_COGNOME-') ||
        comp.id.startsWith('CODICE_FISCALE-')
      ) {
        const dpdKey =
          comp.name === 'meseAnno' ? 'meseAnno' : comp.name.toLowerCase()
        const rezKey = TYPES[dpdKey]
        comp.value = !!titoValue.datiContatto && !!titoValue.datiContatto[rezKey] ? titoValue.datiContatto[rezKey] : '' 
      }
      if (comp.refDataTeJsObj && comp.refDataTeJsObj === 'indirectPepDetail') {
        dpdKey =
          comp.refDataTeJs === 'tipolegame' ? 'tipoLegame' : comp.refDataTeJs
          comp.value = !!titoValue.indirectPepDetail && !!titoValue.indirectPepDetail[dpdKey] ? titoValue.indirectPepDetail[dpdKey] : ''
      }
      if (comp.refDataTeJsObj && comp.refDataTeJsObj === 'directPepDetail') {
        dpdKey = comp.refDataTeJs
        comp.value = !!titoValue.directPepDetail && !!titoValue.directPepDetail[dpdKey] ? titoValue.directPepDetail[dpdKey] : '' 
      }
    })

    if (user.userComponents['TITOLARE_DATA-EFFETTIVO_SI']) {
      user.userComponents['TITOLARE_DATA-EFFETTIVO_SI'].value =
        titoValue.legale_repre === 'SI' ? 'selected' : ''
      user.userComponents['TITOLARE_DATA-EFFETTIVO_NO'].value =
        titoValue.legale_repre === 'SI' ? '' : 'selected'
      /* user.open = false */
    }

    user.userComponents['SZ0025-SS0052_DM0097_RI0022'].value =
      titoValue.directPep === 'SI' ? 'selected' : ''
    user.userComponents['SZ0025-SS0052_DM0097_RI0023'].value =
      titoValue.directPep === 'SI' ? '' : 'selected'

    user.userComponents['SZ0025-SS0163_DM0503_RI0568'].value =
      titoValue.indirectPep === 'SI' ? 'selected' : ''
    user.userComponents['SZ0025-SS0163_DM0503_RI0569'].value =
      titoValue.indirectPep === 'SI' ? '' : 'selected'

    if ( !!titoValue.directPepDetail && titoValue.directPepDetail.inCorso)  
    {
      user.userComponents['SZ0025-SS0162_DM0501_RI0565'].value =
        titoValue.directPepDetail.inCorso === 'SI' ? 'selected' : ''
      user.userComponents['SZ0025-SS0162_DM0501_RI0566'].value =
        titoValue.directPepDetail.inCorso === 'SI' ? '' : 'selected'
    }
    if ( !!titoValue.indirectPepDetail && titoValue.indirectPepDetail.inCorso) 
    {
      user.userComponents['SZ0025-SS0163_DM0507_RI0573'].value =
        titoValue.indirectPepDetail.inCorso === 'SI' ? 'selected' : ''
      user.userComponents['SZ0025-SS0163_DM0507_RI0574'].value =
        titoValue.indirectPepDetail.inCorso === 'SI' ? '' : 'selected'
    }
  //})

  // dispatch({
  //   type: SET_TITOLARE_LIST,
  //   titolareList: titolareList
  // })
}
//Add titolare User
export const addTitolareUser = () => (dispatch, getState) => {
  const { step } = getState()
  // const widgets_ = step && step.widgets_ ? step.widgets_ : []
  // const TITOLARE_WIDGETS = ['FLOW_BAR', 'TITOLARE_EFFETTIVO']
  // let acwidgets = TITOLARE_WIDGETS.map(k => widgets_.find(w => w.name === k))
  // const staticWidgets = TitolareStatic.getTitolareEffettivoComponent()
  // if (staticWidgets.widgets && acwidgets) {
  //   acwidgets = [...acwidgets, ...staticWidgets.widgets]
  // }
  // acwidgets.find(w => {
  //   if (w && w.name === 'TITOLARE_DATA') {
  //     acwidgets.splice(acwidgets.indexOf(w), 1)
  //   }
  // })

  // const { entities } = normalize(acwidgets, widgetListSchema)
  // const widgets = extendModel(entities.widgets)
  // const components = extendModel(entities.components, null, {
  //   dispatch,
  //   widgets: entities.widgets
  // })

  dispatch(validateStep())
  if (!Object.keys(getState().components).find(k => isEntityInvalid(k, getState().components))) {
    step.userCounter = step.userCounter + 1
    const userDetails = {
      id: step.userCounter,
      userWidgets: JSON.parse(JSON.stringify(step.titoWidgets)),
      userComponents: JSON.parse(JSON.stringify(step.titoComponents)),
      type: "add"
    }
    dispatch(addTitolareUserToObject(userDetails, step.userCounter))
    window.scrollTo(0, 0)
  }
}

//Update Titolare User
//export const updateTitolareUser = id => (dispatch, getState) => {
// const { widgets, components, step } = getState()
// const titolareList = step.titolareList
// const prev = titolareList.find(user => user.open)
// const current = titolareList.find(user => user.id === parseInt(id))
// if (current) {
//   current.open = true
// }
// if (prev && prev.open) {
//   prev.userWidgets = JSON.parse(JSON.stringify(widgets))
//   prev.userComponents = JSON.parse(JSON.stringify(components))
//   prev.open = false

//   if (prev.id !== 0 && prev.userWidgets.TITOLARE_DATA) {
//     prev.userWidgets.TITOLARE_DATA.active = false
//     prev.userWidgets.TITOLARE_DATA.status = ['hidden']
//   }
//   titolareList[prev.id] = prev
// }
// // if (step.userCounter !== 0) {
// //   current.userWidgets.TITOLARE_DATA.active = false
// //   current.userWidgets.TITOLARE_DATA.status = ['hidden']
// // }
// dispatch({
//   type: SET_TITOLARE_LIST,
//   titolareList: titolareList
// })
//}

//Update User Component
export const updateUserComponent = () => (dispatch, getState) => {
  const { widgets, components, step } = getState()
  const titolareList = step.titolareList
  const uc = titolareList.find(user => user.open)
  if (uc) {
    uc.userWidgets = JSON.parse(JSON.stringify(widgets))
    uc.userComponents = JSON.parse(JSON.stringify(components))
    Object.keys(uc.userComponents).forEach(k => {
      uc.userComponents[k].validations = components[k].validations
      // if(k === 'DOCUMENTO-TIPO_DOCUMENTO'){
      //   uc.userComponents[k].values = uc.userComponents[k].values.length === 0 ? components[k].values : uc.userComponents[k].values
      // }
    })
    titolareList[uc.id] = uc
  }
  dispatch({
    type: SET_TITOLARE_LIST,
    titolareList: titolareList
  })
}

export const digitalSignCheckCall = () => {
  return API.checkContract().then(({ data }) => data)
}

export const getContractList = () => {
  return API.request({ endpoint: 'wgt/sign/contractlist' })
}

export const downloadPdf = (url) => {
  window.pdfLoaderDispatch(showLoading())
  request({
    endpoint: url,
    method: "GET",
    headers: { 'Content-Type': 'application/pdf' }
  }).then(res => {
    window.pdfLoaderDispatch(hideLoading())
  });
}

window.downloadPdf = downloadPdf;

export const getPdfAnchorTag = (text, contracts) => (
  `<a class="clickable" onclick="downloadPdf('wgt/utils/stampa/contract/${contracts.stampeId}/${contracts.barCode}.pdf')">${text}</a>`
)

export const updateDiFarmaComponent = (loadedWidgets, json) => (
  dispatch,
  getState
) => {
  const { step, product } = getState()
  dispatch(disableBtn(step))
  loadedWidgets=!!loadedWidgets && Object.keys(loadedWidgets).length>0?loadedWidgets:step.widgets_.filter(w => w.name === 'FLOW_BAR')
  json.step.widgets=!!json && !!json.step && !!json.step.widgets && json.step.widgets.length>0?json.step.widgets:step.widgets_
  json.step.contactId=!!json && !!json.step && !!json.step.contactId?json.step.contactId:step.contactId
  json.step.number=!!json && !!json.step && !!json.step.number?json.step.number:step.number
  json.step.name=!!json && !!json.step && !!json.step.name?json.step.name:step.name
  json.step.guid=!!json && !!json.step && !!json.step.guid?json.step.guid:step.guid
  json.step.last=!!json && !!json.step && !!json.step.last?json.step.last:step.last

  //const staticWidgets = FirmeStatic.getFirmeComponent() 
  const widgetCode = json.step.widgets
    .filter(w => w.name.toUpperCase() === 'ATTIVA_REVOCA_FIRMA')
    .map(w => w.code)
  //staticWidgets.widgets[0].code = widgetCode[0] 
  let updateContractsComponents = []
  let updateFirma = null
  let posplanurl='OnboardRequestDetails/FetchPOSPlan'
  let posplanbody= {
    GUID: !!json.step.guid?json.step.guid:step.guid
  }
  let posPlan="";
  let promocodeFromAPI="";
  FetchPOSPlan(posplanurl, posplanbody).then(posPlanJson => {
    dispatch(showLoading())
    posPlan = !!posPlanJson.payLoad && !!posPlanJson.payLoad.Plan && posPlanJson.payLoad.Plan.toUpperCase()==='FLEX' ? 'flex' : (!!posPlanJson.payLoad && !!posPlanJson.payLoad.Plan && posPlanJson.payLoad.Plan.toUpperCase() === 'FLEXCRS'?'flexCRS':(!!posPlanJson.payLoad && !!posPlanJson.payLoad.Plan && posPlanJson.payLoad.Plan.toUpperCase() === 'FLATCRS'?'flatCRS':'flat'));   
    promocodeFromAPI=!!posPlanJson.payLoad && !!posPlanJson.payLoad.ReferalCode && posPlanJson.payLoad.ReferalCode
  digitalSignCheckCall().then(({ digitalsign }) => {
    dispatch(showLoading())
    getContractList().then(response => {
      dispatch(hideLoading())
      dispatch(handleServerErrors(response))
      if (response.status === 'success') {
        const { contracts, holderInfo } = response.data
        const contractList = contracts.filter(
          ({ sign }) => sign !== '' && sign.toLowerCase() !== 'never_uploaded'
        )
        const signedContractList = contractList.filter(
          ({ sign }) => sign.toLowerCase() === 'true'
        )
        let contractFirmaActive = true
        updateContractsComponents = contractList.map((contract, index) => {
          const { widgets } = FirmeStatic.getDiFarmaComponents()
          widgets[0].name = `DIFARMA_${index}`
          widgets[0].components[2].url = ''

           //Rewamp of whole digital contracts in last step (All flows)	
           let subUrl = '/wgt/utils/stampa/contract/'
           let subLabel = widgets[0].components.find(d => d.name === 'SUB_LABEL').value 
 
           let contrattoTitle = ""
           let contrattoDescription = ""
           let contracts = {};
            if(index === 0)
            {
              contracts = contractList.find(d => d.tipo === 'POS_EN')
              if(posPlan==="flex" || (posPlan && posPlan.toUpperCase()==="FLEXCRS"))
              {
                contrattoTitle =`<b>Contratto di Vendita e Licenza d’uso software</b>`
                contrattoDescription=`<p>Nel  ${contracts ? getPdfAnchorTag("contratto di vendita e licenza d’uso software", contracts):"contratto di vendita e licenza d’uso software"} accetti di:</p>
                <ul class='btn-indent-txt'>
                  <li>Acquistare il POS Android a 100€ + IVA</li>
                  <li>Far addebitare il relativo costo sul conto corrente indicato</li>
                  <li>Mantenere il contratto di acquiring collegato alla presente proposta attivo per ottenere assistenza sul tuo dispositivo</li>
                `;
              }
              else{
              contrattoTitle = `<b>Contratto di noleggio POS</b>`
              contrattoDescription = `
                  <p>
                    Nel 
                    ${contracts ? getPdfAnchorTag("contratto di noleggio POS", contracts) : "contratto di noleggio POS"}
                    accetti di:
                  </p>
                  <ul class='btn-indent-txt'>
                    <li>Pagare un canone mensile di 17 o 22 euro per POS in base a quanto selezionato</li>
                    <li>Ricevere in comodato d'uso il/i terminale/i POS Android</li>
                    <li>Far accreditare gli importi delle transazioni tramite POS sul conto corrente indicato</li>
                  </ul>
                `;
              }
            }
            else if(index === 1){
              contracts = contractList.find(d => d.tipo === 'POS_BS')
              contrattoTitle = `<b>Contratto di acquiring</b>`
              if(posPlan==="flex" || (posPlan && posPlan.toUpperCase()==="FLEXCRS"))
              {
                contrattoDescription = `
                  <p>
                    Nel
                    ${contracts ? getPdfAnchorTag("contratto di acquiring", contracts) : "contratto di acquiring"}
                    accetti di:
                  </p>
                  <ul class='btn-indent-txt'>
                    <li>Pagare l’ 1% di commissioni per tutte le transazioni tramite POS per carte di debito, credito e PagoBancomat</li>
                    <li>Pagamento del bollo di attivazione di 16 euro</li>
                  </ul>
                `;                
              }
              else {
              contrattoDescription = `
                  <p>
                    Nel
                    ${contracts ? getPdfAnchorTag("contratto di acquiring", contracts) : "contratto di acquiring"}
                    accetti di:
                  </p>
                  <ul class='btn-indent-txt'>
                    <li>Non pagare commissioni per tutte le transazioni tramite POS per carte di debito, credito e PagoBancomat</li>
                    <li>Pagamento del bollo di attivazione di 16 euro</li>
                  </ul>
                `;
              }
            }
            else if(index === 2){
              contracts = contractList.find(d => d.tipo === 'Questionario Antiriciclaggio')
              contrattoTitle = `<b>Questionario antiriciclaggio</b>`
              contrattoDescription = `
                Nel
                ${contracts ? getPdfAnchorTag("questionario antiriciclaggio", contracts) : "questionario antiriciclaggio"}
                accetti quanto dichiarato in fase di richiesta in materia in antiriciclaggio per adempiere agli obblighi di ageduata verifica.
              `;
            }
            else if(index === 3){
              contracts = contractList.find(d => d.tipo === 'Privacy')
              contrattoTitle = `<b>Informativa trattamento dei dati personali</b>`
              contrattoDescription = `
                Nell'
                ${contracts ? getPdfAnchorTag("informativa sul trattamento dei dati personali", contracts) : "informativa sul trattamento dei dati personali"}
                accetti le caratteristiche relative al trattamento dei tuoi dati personali da parte di Banca Sella S.p.A e tutte le società del gruppo, che hai selezionato in fase di richiesta.
              `;
            }
           widgets[0].components[0].value = contrattoTitle
           widgets[0].components.find(d => d.name === 'SUB_LABEL').value = contrattoDescription;
          window.pdfLoaderDispatch = dispatch;
         
          widgets[0].components[2].barcode = contract.barCode
          widgets[0].components[2].tipo = contract.tipo


          widgets[0].components[2].body = {
            barcode: contract.barCode,
            stampeId: contract.stampeId,
            smsContent: contract.tipo
          }       
          widgets[0].components[2].value = contract.sign === 'false' ? widgets[0].components[2].value : 'Firmato' 
          widgets[0].components[2].disabled = contract.sign === 'false' ? false : true
          // if (index === 0) { 
              // widgets[0].components[2].disabled = false 
            // }

          if (
            holderInfo.digitalsign &&
            contract.sign.toLowerCase() === 'true'
          ) {
            widgets[0].components[2].type = 'active'
            widgets[0].components[2].disabled = true
            widgets[0].components[2].value = 'FIRMATO'
          }
          if (
            holderInfo.digitalsign &&
            contract.sign.toLowerCase() === 'false' &&
            contractFirmaActive
          ) {
            updateFirma = {
              id: `${widgets[0].name}-${contract.azioni}`,
              update: {
                disabled: false,
                type: 'sella',
                action: Object.assign({}, widgets[0].components[2].action, {
                  value: 'Attivata',
                  type: 'inverse',
                  disabled: true,
                  barcode: contract.barCode,
                  fetch: {
                    attivata: {
                      url: 'wgt/sign/url',
                      body: {
                        docId: contract.barCode,
                        smsContent: contract.tipo
                      },
                      mappingEvent: 'DiFarmaIframeSrcSetter'
                    }
                  },
                  updateComponentId: `${widgets[0].name}-IFRAME`,
                  toggleVisibility: {
                    show: {
                      fields: [`${widgets[0].name}-IFRAME`]
                    }
                  }
                })
              }
            }
            contractFirmaActive = false
          }
          return widgets[0]
        })
        if (contractList.length === signedContractList.length) {
          dispatch(enableBtn(step))
        }
      }
      let staticPosPlanWidgets = JSON.parse(
        JSON.stringify(getPosPlanComponent())
      )
      staticPosPlanWidgets.widgets[0].components[0].fetchPosPlan = {
        url:'OnboardRequestDetails/FetchPOSPlan', //'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/FetchPromoCode',//'https://172.17.4.63/magtek/OnboardRequestDetails/FetchPromoCode',
        body: {
          GUID: json.step.guid
        },
        mappingEvent: 'FetchPOSPlan'
      }

      const widgets = [
        ...loadedWidgets,
        //...staticWidgets.widgets, 
        ...staticPosPlanWidgets.widgets,
        ...updateContractsComponents
      ]

      // Coupon start
      //if(posPlan==="flat") {
        const promoCodeStaticComp = JSON.parse(JSON.stringify(getPromoCodeComponent()))
        promoCodeStaticComp.widgets[0].components[0].fetchPromoCode = {
          url:'OnboardRequestDetails/FetchPromoCode', //'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/FetchPromoCode',//'https://172.17.4.63/magtek/OnboardRequestDetails/FetchPromoCode',
          body: {
            GUID: json.step.guid
          },
          mappingEvent: 'FetchPromoCode'
        }
        if(!!promocodeFromAPI)
        {
          promoCodeStaticComp.widgets[0].components[0].value=promocodeFromAPI;
        }
        promoCodeStaticComp.widgets[0].components[0].validations={
          //skipLazy: true,
          //isRequired: true,
          default: [
            {
              validate: Model.VALIDATION_METHODS.filled,
              getErrorMessage: Model.VALIDATION_ERRORS.filled
            }
          ],
          // overrides: [
          //   {
          //     validate: Model.VALIDATION_METHODS.filled,
          //     getErrorMessage: Model.VALIDATION_ERRORS.filled
          //   }
          // ],
          // url: 'PromoCodeManagement/ValidatePromoCode',//'https://sandbox.gestpay.net/PromocodesService/PromoCodeManagement/ValidatePromoCode',//'https://172.17.4.63/magtek/PromoCodeManagement/ValidatePromoCode'
          fields: ['PROMO-PromoCode']
        }
        widgets.push(promoCodeStaticComp.widgets[0]);
      //}
      // Coupon end
      
      const { entities } = normalize(widgets, widgetListSchema)
      dispatch(
        updateAllWidgets(
          extendModel(entities.widgets, null, {
            dispatch,
            step: json.step.number,
            product: product.prodCode,
            name: json.step.name
          })
        )
      )
      dispatch(
        updateAllComponents(
          extendModel(entities.components, null, {
            dispatch,
            widgets: entities.widgets,
            step: json.step.number,
            product: product.prodCode,
            name: json.step.name
          })
        )
      )
      dispatch(activateSign(digitalsign))
      if (updateFirma !== null) {
        dispatch(updateComponent(updateFirma.id, updateFirma.update))
      }
    })
  })
})
}

//delete titolare user
export const deleteTitolareUser = user => (dispatch, getState) => {
  const { step } = getState()
  const titolareList = step.titolareList
  if (titolareList.length <= 5 && titolareList.length > 1) {
    titolareList.splice(user, 1)
    step.userCounter = step.userCounter - 1

    titolareList.map(user => {
      if (user.id !== titolareList.indexOf(user)) {
        user.id = titolareList.indexOf(user)
      }
    })
    titolareList[titolareList.length-1].open = true 
    let count = step.userCounter
    dispatch({ type: USER_COUNTER , userCounter: count})
    dispatch({
      type: SET_TITOLARE_LIST,
      titolareList: titolareList
    })
  }
}

export const showWebcamModal = component => (dispatch /*, getState*/) => {
  dispatch({ type: SHOW_WEBCAM_MODAL, component })
}

export const hideAddressModal = () => (dispatch /*, getState*/) => {
  dispatch({ type: HIDE_ADDRESS_MODAL })
}

export const showAddressModal = component => (dispatch /*, getState*/) => {
  dispatch({ type: SHOW_ADDRESS_MODAL, component })
}

export const hideWebcamModal = () => (dispatch /*, getState*/) => {
  dispatch({ type: HIDE_WEBCAM_MODAL })
}

export const showLoading = () => (dispatch /*, getState*/) => {
  dispatch({ type: SHOW_LOADING })
}
export const hideLoading = () => (dispatch /*, getState*/) => {
  dispatch({ type: HIDE_LOADING })
}
export const enableBtn = step => (dispatch /*, getState*/) => {
  dispatch({
    type: ENABLE_BUTTON,
    step
  })
}
export const disableBtn = step => (dispatch /*, getState*/) => {
  dispatch({
    type: DISABLE_BUTTON,
    step
  })
}
export const showAPIAlertModel = () => (dispatch /*, getState*/) => {
  dispatch({ type: SHOW_API_ALERT_MODAL })
}

export const updateTitolareList = titolareList => dispatch => {
  dispatch({
    type: SET_TITOLARE_LIST,
    titolareList: titolareList
  })
}

export const hideAlert = component => dispatch => {
  dispatch(updateComponent(component.id, { status: ['hidden'] }))
}
export const showAlert = component => dispatch => {
  dispatch(
    updateComponent(component.id, {
      value: component.value,
      title: component.title,
      status: []
    })
  )
}



// WEBPACK FOOTER //
// ./state/actions/stepActions.js